<template>
    <div class="container-fluid" id="dvcrud">
        <div class="row">
            <div class="col-md-12">
                <breadcrumb v-bind:bcitens="itensbc" v-bind:mtdcancelar="mtdcancelaredicao"></breadcrumb>
            </div>
            <div class="col-md-12">
                <consultanotafor v-bind:idpedidocompra="vidpedidonotafor"  v-bind:idfornecedor="vidfornecedornota"></consultanotafor>
                <consultaprodutos v-bind:idtabela="vidtabela" v-bind:showprtabela="vshowprtabela" v-bind:filtrotipo="tipopropesquisa"></consultaprodutos>
                <div id="pnlista" class="card" style="display: none;">
                    <div class="card-header"><span id="titlista">LISTAGEM DE {{ itensbc.item1.titulo }}</span>
                        <router-link to="/">
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                        </router-link>
                    </div>
                    <div class="card-body" style="padding: 10px;">
                        <div class="row">
							<div class="col-sm-12 col-md-4 col-lg-4">
								<span class="lblselect2">Filial:</span>
								<select id="cbfilialpesq" data-placeholder="Selecione uma filial" v-model="pidfilial" data-allow-clear="true" style="width:100%;">
								</select>
							</div>  
                            <div class="col-sm-12 col-md-2 col-lg-2">
								<label for="cbfiltroperiodo">Tipo:</label>
								<select class="form-control form-control-sm" v-model="vtppesqu" id="cbfiltroperiodo" @change="mtdlimpar_listagem()">
									<option value="0">Sistema</option>
									<option value="1">Fornecedor</option>
								</select>
							</div>                           
                            <div class="col-12 col-sm-12 col-md-2 col-lg-2">
                                <label for="edidpedidopesq">Nr. Pedido:</label>
                                <input id="edidpedidopesq" type="text" v-mask="'###############'" class="form-control form-control-sm" v-model="pid" @keydown="mtdlimpar_listagem()">
                            </div>                                                       
                            <div class="col-sm-12 col-md-4 col-lg-4">
                                <span class="lblselect2">Fornecedor:</span>
                                <select id="cbfornecedorpesq" data-placeholder="Selecione um fornecedor" data-allow-clear="true"
                                        style="width:100%;" v-model="pidfornecedor">
                                </select>
                            </div>
							<div class="col-sm-12 col-md-1 col-lg-1">
								<label for="cbfiltroperiodo">Período:</label>
								<select class="form-control form-control-sm" id="cbfiltroperiodo" v-model="pfiltroperiodo" v-bind="selecionaperiodo" @change="mtdlimpar_listagem()">
									<option value="0">Não</option>
									<option value="1">Sim</option>
								</select>
							</div>
							<div class="col-sm-12 col-md-1 col-lg-1">
								<label for="cbfiltropor">Por:</label>
								<select class="form-control form-control-sm" id="cbfiltropor" v-model="pfiltropor" v-bind:disabled="hab_desab_periodo" @change="mtdlimpar_listagem()">
									<option value="0">Emissão</option>
									<option value="1">Entrega</option>
								</select>
							</div>                            
							<div class="col-sm-12 col-md-2 col-lg-2">
								<label for="eddtini">De:</label>
								<div class="input-group">
									<date-picker id="eddtini" v-model="pdtini" :config="options" class="form-control form-control-sm" v-bind:disabled="hab_desab_periodo" @change="mtdlimpar_listagem()"></date-picker>
									<div class="input-group-append">
										<span class="input-group-text"><i class="fa fa-calendar"></i></span>
									</div>								
								</div>
							</div>
							<div class="col-sm-12 col-md-2 col-lg-2">
								<label for="eddtfim">até:</label>
								<div class="input-group">
									<date-picker id="eddtfim" v-model="pdtfim" :config="options" class="form-control form-control-sm" v-bind:disabled="hab_desab_periodo" @change="mtdlimpar_listagem()"></date-picker>
									<div class="input-group-append">
										<span class="input-group-text"><i class="fa fa-calendar"></i></span>
									</div>																			
								</div>
							</div>                                                        
                            <div class="col-6 col-sm-6 col-md-2 col-lg-2">
                                <label for="cbsituacaopesq">Situação:</label>
                                <select name="cbsituacaopesq" class="form-control form-control-sm" id="cbsituacaopesq" v-model="psituacao" @change="mtdlimpar_listagem()">
									<option value="0">Em digitação</option>
									<option value="1">Aguardando</option>
                                    <option value="2">Entregue</option>
                                    <option value="3">Cancelado</option>
                                    <option value="4">Todas</option>
                                </select>
                            </div>                                                        
                            <div class="col-6 col-sm-6 col-md-1 col-lg-1">
                                <label for="cbqtdreg">Registros:</label>
                                <select name="cbqtdreg" class="form-control form-control-sm" id="cbqtdreg" v-model="pqtdregistros" @change="mtdlimpar_listagem()">
                                    <option value="10">10</option>
                                    <option value="20">20</option>
                                    <option value="30">30</option>
                                    <option value="40">40</option>
                                    <option value="50">50</option>
                                    <option value="99999999999">Todos</option>
                                </select>
                            </div>
                            <div class="col-md-2" style="padding-top: 25px;">
                                <div class="custom-control custom-switch" style="width: 100%; position: absolute; left:">
                                    <input type="checkbox" class="custom-control-input" id="swresumoped" name="swresumoped" v-model="presumoped">
                                    <label class="custom-control-label" for="swresumoped">Resumo dos pedidos</label>
                                </div>						                                
                            </div>  
                            <div class="col-6 col-sm-6 col-md-1 col-lg-1">
                                <button type="button" id="btlistar" class="btn btn-primary btn-sm btn-block" @click.prevent="mtdexecutapesquisa()"><i class="fa fa-search"></i></button>
                            </div>
                            <div class="col-md-12" style="margin-top: 10px;">
                                <vue-bootstrap4-table ref="reflstpedidos"
                                        :rows="lstpedido"
                                        :columns="columns"
                                        :config="config"
                                        :classes="classes">
                                    <template slot="empty-results">
                                        <div class="col-md-12 text-center">Sem dados para visualização</div>
                                    </template>
                                    <!-- ícones de ordenação da table -->
                                    <template slot="sort-asc-icon">
                                        <i class="fa-icones-ordenacao fa fa-sort-asc"></i>
                                    </template>
                                    <template slot="sort-desc-icon">
                                        <i class="fa-icones-ordenacao fa fa-sort-desc"></i>
                                    </template>
                                    <template slot="no-sort-icon">
                                        <i class="fa-icones-ordenacao fa fa-unsorted"></i>
                                    </template>                                    
                                    <!--  -->                                    
                                    <template slot="id_f" slot-scope="item">
                                        {{ mtdformatarzeros(item.row.id, 8) }}
                                    </template>
                                    <template slot="slot_totalpedido" slot-scope="item">
                                        <strong style="color: #545b62;">{{ mtdformatavalordecimal(item.row.totalpedido, 2) }}</strong>
                                    </template> 
                                    <template slot="slot_entregue" slot-scope="item">
                                        <strong style="color: #65a56c;">{{ mtdformatavalordecimal(item.row.totentregue, 2) }}</strong>
                                    </template> 
                                    <template slot="slot_restante" slot-scope="item">
                                        <strong style="color: #6585a5;">{{ mtdformatavalordecimal(item.row.totrestante, 2) }}</strong>
                                    </template> 
                                    <template slot="slot_notafor" slot-scope="item">
                                        <button type="button" class="btn btn-info btn-sm btn-opcrud ajt-btn" @click.prevent="mtdvernotasfor(item.row)"><i class="fa fa-info-circle"></i></button>
                                    </template>    
                                    <template slot="slot_situacao" slot-scope="item">
                                        <span v-if="parseInt(item.row.situacao) === 0"      class="badge badge-pill badge-primary bdg-digitacao" style="">Em digitação</span>
                                        <span v-else-if="parseInt(item.row.situacao) === 1" class="badge badge-pill badge-primary bdg-aguardando">Aguardando</span>
                                        <span v-else-if="parseInt(item.row.situacao) === 2" class="badge badge-pill badge-primary bdg-entregue">Entregue</span>
                                        <span v-else-if="parseInt(item.row.situacao) === 3" class="badge badge-pill badge-primary bdg-cancelado">Cancelado</span>
                                    </template>                                                                    
                                    <template slot="opcoes" slot-scope="item">
                                        <button type="button" class="btn btn-primary btn-sm" @click.prevent="mtdmostrarmenu(item.row)" style="width: 35px;">
                                            <i class="fa fa-navicon"></i>
                                        </button>
                                    </template>
                                </vue-bootstrap4-table>
                            </div>
                            <div class="col-md-12">
                                <ul class="list-group">
                                    <li class="list-group-item d-flex justify-content-between align-items-center" style="padding: 10px;">
                                        Registros
                                        <span class="badge badge-info badge-pill text-right bdg-qtd-reg-info">{{lstpedido.length}}</span>
                                    </li>
                                    <!-- <div v-show="lstpedido.length > 0" >
                                        <li  class="list-group-item d-flex justify-content-between align-items-center" style="padding: 10px;">
                                            Em digitação
                                            <span class="badge badge-info badge-pill text-right bdg-qtd-reg-info dgl">{{vqtddigitacao}}</span>
                                        </li>
                                        <li  class="list-group-item d-flex justify-content-between align-items-center" style="padding: 10px;">
                                            Aguardando
                                            <span class="badge badge-info badge-pill text-right bdg-qtd-reg-info agl">{{vqtdaguardando}}</span>
                                        </li>
                                        <li  class="list-group-item d-flex justify-content-between align-items-center" style="padding: 10px;">
                                            Entregue
                                            <span class="badge badge-info badge-pill text-right bdg-qtd-reg-info enl">{{vqtdentregue}}</span>
                                        </li>
                                        <li  class="list-group-item d-flex justify-content-between align-items-center" style="padding: 10px;">
                                            Cancelado
                                            <span class="badge badge-info badge-pill text-right bdg-qtd-reg-info cal">{{vqtdcancelado}}</span>
                                        </li>
                                    </div>    -->
                                </ul>
                                <div v-show="presumoped" class="row justify-content-center" style="margin-top: 10px;">
                                    <div class="col-sm-12 col-md-6 col-lg-6">
                                        <ul class="list-group">
                                            <a class="list-group-item text-center tit-list-group-item font-weight-bold text-black-50" style="color: #cccccc!important; background-color: #343a40; padding: 5px;">RESUMO DOS PEDIDOS</a>
                                            <a class="list-group-item list-group-item-action d-flex justify-content-between align-items-center lstdetrec">Em digitação<strong style="padding-right: 60%;"></strong><span class="badge badge-secondary bgdigitacao"> {{ mtdformatavalordecimal(vtotdigitacao) }}</span></a>
                                            <a class="list-group-item list-group-item-action d-flex justify-content-between align-items-center lstdetrec">Aguardando entrega<strong style="padding-right: 60%;"></strong><span class="badge badge-secondary bgaguardando"> {{ mtdformatavalordecimal(vtotaguardando) }}</span></a>
                                            <a class="list-group-item list-group-item-action d-flex justify-content-between align-items-center lstdetrec">Entregue  <strong style="padding-right: 60%;"></strong><span class="badge badge-secondary bgentregue">{{ mtdformatavalordecimal(vtotentregue) }}</span></a>
                                            <a class="list-group-item list-group-item-action d-flex justify-content-between align-items-center lstdetrec">Cancelados  <strong style="padding-right: 60%;"></strong><span class="badge badge-secondary bgcancelados">{{ mtdformatavalordecimal(vtotcancelado) }}</span></a>  
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            
                        </div>
                        <div v-show="presumoped" class="row" style="padding-top: 25px;">
                            <div class="col-12">
                                 <div class="row">
                                    <div  class="col-md-8">
                                        <div class="card">
                                            <div class="card-header card-dash">
                                                <span class="tit-card-dash">Compras por Filiais</span>
                                            </div>
                                            <div class="card-body" style="padding-bottom: 10px;">
                                                <div class="row">
                                                    <div class="col-md-12" style="margin-top: -40px;">
                                                        <graficobarra 

                                                            :agrupamento="legendaspedidofil"
                                                            :series="dadospedidosfil"
                                                            :tipo="true"
                                      
                                                        ></graficobarra>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>                   
                                    </div>
                                    
                                    <div   class="col-md-4">
                                        <div class="card">
                                            <div class="card-header card-dash">
                                                <span class="tit-card-dash">Meta filial</span>
                                            </div>
                                            <div class="card-body" style="padding-bottom: 10px;">
                                                <div class="row">
                                                    <div class="col-md-12" style="margin-top: -40px;">
                                                        <graficohalfdonut :rotulo="'DETALHES:'"
                                                             :legendas="legendasmeta"
                                                             :dados="dadosmeta"
                                                        ></graficohalfdonut>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>                   
                                    </div>

                                    <div style="padding-top: 25px;" class="col-md-6">
                                        <div class="card">
                                            <div class="card-header card-dash">
                                                <span class="tit-card-dash">Compras por setores</span>
                                            </div>
                                            <div class="card-body" style="padding-bottom: 10px;">
                                                <div class="row">
                                                    <div class="col-md-12" style="margin-top: -40px;">
                                                        <graficodoughnut :rotulo="'DETALHES:'"
                                                             :legendas="legendassetorpro"
                                                             :dados="dadossetorpro"
                                                        ></graficodoughnut>
                                                    </div>


                                                    <div class="col-md-12">
                                                        <ul class="lista-card-graficos" style="padding-left: 0px; margin-bottom: 0px; margin-top: -40px; height: 200px; overflow:auto; margin-left: 25%;
                                                             margin-right: 25%;">
                                                            <li v-for="(item, indice) in dadossetorpro" :key="indice" class="li-item-card-dash" style="height: 15px;">
                                                                <span class="txt-item-card-dash-grafico">{{item.name }}</span>
                                                                <span class="txt-item-card-dash-grafico" style="float: right;">{{ mtdformatavalordecimal(parseFloat(item.value)) }} ({{ mtdformatavalordecimal( parseFloat(item.value) / parseFloat(totalsetores) * 100) }}%)
                                                                </span>
                                                            </li>
                                                        </ul>                                            
                                                    </div>

                                                </div>
                                            </div>
                                        </div>                   
                                    </div>

                                    <div  class="col-md-6" style="padding-top: 25px;">
                                        <div class="card">
                                            <div class="card-header card-dash">
                                                <span class="tit-card-dash">Compra por Grupos</span>
                                            </div>
                                            <div class="card-body" style="padding-bottom: 10px;">
                                                <div class="row">
                                                    <div class="col-md-12" style="margin-top: -40px;">
                                                        <graficodoughnut :rotulo="'DETALHES:'"
                                                                :legendas="legendasgrupospro"
                                                                :dados="dadosgrupospro"
                                                        ></graficodoughnut>
                                                    </div>


                                                    <div class="col-md-12">
                                                        <ul class="lista-card-graficos" style="padding-left: 0px; margin-bottom: 0px; margin-top: -40px; height: 200px; overflow:auto; margin-left: 25%;
                                                             margin-right: 25%;">
                                                            <li v-for="(item, indice) in dadosgrupospro" :key="indice" class="li-item-card-dash" style="height: 15px;">
                                                                <span class="txt-item-card-dash-grafico">{{item.name }}</span>
                                                                <span class="txt-item-card-dash-grafico" style="float: right;">{{ mtdformatavalordecimal(parseFloat(item.value)) }} ({{ mtdformatavalordecimal( parseFloat(item.value) / parseFloat(totalgrupos) * 100) }}%)
                                                                </span>
                                                            </li>
                                                        </ul>                                            
                                                    </div>

                                                </div>
                                            </div>
                                        </div>                   
                                    </div>
                                    
                                    <div  class="col-md-12" style="padding-top: 25px;">
                                        <div class="card">
                                            <div class="card-header card-dash">
                                                <span class="tit-card-dash">Compras por marca</span>
                                            </div>
                                            <div class="card-body" style="padding-bottom: 10px;">
                                                <div class="row">
                                                    <div class="col-md-12 grafico-line" style="margin-top: -40px;">
                                                        <graficotreemap 
                                                            :rotulo="'DETALHES:'"
                                                            :legendas="legendasmarca"
                                                            :dados="dadosmarca"
                                                            :total="totalmarcas"
                                                        ></graficotreemap>
                                                    </div>


                                                    <div style="padding-top: 60px;" class="col-md-12">
                                                        <ul class="lista-card-graficos" style="padding-left: 0px; margin-bottom: 0px; margin-top: -40px; height: 200px; overflow:auto;     margin-left: 25%;
                                                             margin-right: 25%;">
                                                            <li v-for="(item, indice) in dadosmarca" :key="indice" class="li-item-card-dash" style="height: 15px;">
                                                                <span class="txt-item-card-dash-grafico">{{ item.name.substring(0, item.name.lastIndexOf('(') !== -1 ? item.name.lastIndexOf('(') : item.name.length).trim() }}</span>
                                                                <span class="txt-item-card-dash-grafico" style="float: right;">{{ mtdformatavalordecimal(parseFloat(item.value)) }} ({{ mtdformatavalordecimal(parseFloat(item.value) / parseFloat(totalmarcas) * 100) }}%)
                                                                </span>
                                                            </li>
                                                        </ul>                                            
                                                    </div>


                                                </div>
                                            </div>
                                        </div>                   
                                    </div>
                                    <div>

                                    </div>
                                    <div  class="col-md-12" style="padding-top: 25px;">
                                        <div class="card ">
                                            <div class="card-header card-dash">
                                                <!-- <span class="tit-card-dash">Previsão de Pagamento </span> -->
                                                <div class="row">
                                                    <div class="col-2">
                                                        <select name="cbsituacaopesq" class="form-control form-control-sm" id="cbsituacaopesq" v-model="ppagamento">
                                                            <option value="0">Pagamento previsto</option>
                                                            <option value="1">Efetivo</option>
                                                        </select>
                                                    </div>
                                                    <div v-show="parseInt(ppagamento)===1" class="col-2">
                                    
                                                        <select id="cbcategfor" data-placeholder="Selecione uma categoria" v-model="vidcategfor" data-allow-clear="true" style="width:100%;">
                                                        </select>
                                                    </div>
                                                    <div class="col-8">
                                                    </div>
                                                </div>  
                                           
                                            </div>
                                            <div class="card-body" style="padding-bottom: 10px;">
                                                <div class="row">
                                                    <div class="col-md-12 grafico-line" style="margin-top: -40px;">
                                                        <template v-if="parseInt(ppagamento)===0">
                                                            <graficoline    :titulo="''"
                                                                            :dados="seriesgraficolinepag"
                                                                            :agrupamento="periodograficolinepag"
                                                                            :legendas="legendagraficolinepag"
                                                            ></graficoline>
                                                        </template>
                                                        <template v-else>
                                                            <graficoline    :titulo="''"
                                                                            :dados="seriescontaspagar"
                                                                            :agrupamento="periodocontaspagar"
                                                                            :legendas="legendacontaspagar"
                                                            ></graficoline>
                                                        </template>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>                   
                                    </div>
                                    <div  class="col-md-12" style="padding-top: 25px;">
                                        <div class="card ">
                                            <div class="card-header card-dash">
                                                <span class="tit-card-dash">Previsão de Recebimento </span>
                                            </div>
                                            <div class="card-body" style="padding-bottom: 10px;">
                                                <div class="row">
                                                    <div class="col-md-12 grafico-line" style="margin-top: -40px;">
                                                        <graficoline    :titulo="''"
                                                                        :dados="seriesgraficoline"
                                                                        :agrupamento="periodograficoline"
                                                                        :legendas="legendagraficoline"
                                                        ></graficoline>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>                   
                                    </div>
                                 </div>
                            </div>
                        </div>
                    </div>
                    <div class="card-footer" style="padding: 10px;">
                        <div class="row">
                            <div class="col-4 col-sm-4 col-md-6 col-lg-6" id="dvpaginacao">
                                <v-pagination
                                        v-model="pagina_atual"
                                        :page-count="pqtd_paginas"
                                        :classes="bootstrapPaginationClasses">
                                </v-pagination>
                            </div>
                            <div class="col-4 col-sm-4 col-md-2 col-lg-2">
                                <div class="dropdown">
                                    <button type="button" class="btn btn-info btn-sm btn-block dropdown-toggle" data-toggle="dropdown">
                                        <i class="fa fa-navicon"></i> Outras
                                    </button>
                                    <div class="dropdown-menu">
                                        <a class="dropdown-item" href="#" @click.prevent="mtdagrupapedidos()"><i class="fa fa-object-group"></i> Agrupar pedidos</a>                                                                                                               
                                    </div>
                                </div>  
                            </div> 
                            <div class="col-4 col-sm-4 col-md-2 col-lg-2">
                                <div class="dropdown">
                                    <button type="button" class="btn btn-info btn-sm btn-block dropdown-toggle" data-toggle="dropdown">
                                        <i class="fa fa-navicon"></i> Imprimir
                                    </button>
                                    <!-- <div class="dropdown-menu">
                                        <div class="d-flex justify-content-between align-items-center px-3">
                                            <a href="#" @click.prevent="mtdimprimirlistagem(0)">
                                                <i class="fa fa-print"></i> Impressão normal
                                            </a>
                                            <button class="btn btn-sm btn-success" @click.prevent="mtdimprimirlistagem(1)" title="Exportar Excel">
                                                <i class="fa fa-file-excel-o"></i>
                                            </button>
                                        </div>

                                        <div class="dropdown-divider"></div>

                                        <div class="d-flex justify-content-between align-items-center px-3">
                                            <a href="#" @click.prevent="mtdimpressaomarca(0)">
                                                <i class="fa fa-print"></i> Impressão por marca
                                            </a>
                                            <button class="btn btn-sm btn-success" @click.prevent="mtdimpressaomarca(1)" title="Exportar Excel">
                                                <i class="fa fa-file-excel-o"></i>
                                            </button>
                                        </div>
                                    </div> -->
                                    <div class="dropdown-menu">
                                        <div class="d-flex justify-content-between align-items-center px-3">
                                            <a href="#" @click.prevent="mtddetalharimpfil(1)">
                                                <i class="fa fa-print"></i> Impressão normal
                                            </a>
                                            <button class="btn btn-sm btn-success corverde" @click.prevent="mtddetalharimpfil(0)" title="Exportar Excel">
                                                <i class="fa fa-file-excel-o"></i>
                                            </button>
                                        </div>

                                        <div class="dropdown-divider"></div>

                                        <div class="d-flex justify-content-between align-items-center px-3">
                                            <a href="#" @click.prevent="mtdimpmarca(1)">
                                                <i class="fa fa-print"></i> Impressão por marca
                                            </a>
                                            <button class="btn btn-sm btn-success corverde" @click.prevent="mtdimpmarca(0)" title="Exportar Excel">
                                                <i class="fa fa-file-excel-o"></i>
                                            </button>
                                        </div>
                                    </div>


                                </div> 
                                <!-- <button type="button" class="btn btn-primary btn-sm btn-block" @click.prevent="mtddetalharimpfil()"><i class="fa fa-print"></i> Imprimir</button> -->
                            </div>
                            <div class="col-4 col-sm-4 col-md-2 col-lg-2">
                                <button type="button" class="btn btn-success btn-sm btn-block" @click.prevent="mtdnovo()"><i class="fa fa-file"></i> Novo</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div id="pncadastro" class="card" style="display:none;">
                    <div class="card-header"><span>{{itensbc.item2.titulo}}</span>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click.prevent="mtdcancelaredicao()"><span aria-hidden="true">&times;</span></button>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" title="Layout arquivo de importação de estoques" style="margin-right: 10px;" @click.prevent="mtdbaixarmatriz()"><span aria-hidden="true"><i class="fa fa-file-excel-o"></i></span></button>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div :class="clonar? 'col-sm-12 col-md-1 col-lg-1' : 'col-sm-12 col-md-2 col-lg-2'">
                                <label for="edid">Nr. Pedido:</label>
                                <input type="text" class="form-control form-control-sm" id="edid" v-model="vid"
                                maxlength="20" disabled/>
                            </div>
							<div :class="clonar? 'col-sm-12 col-md-2 col-lg-2' : 'col-sm-12 col-md-3 col-lg-3'">
								<span class="lblselect2">*Filial:</span>
								<select id="cbfilial" data-placeholder="Selecione uma filial" v-model="vidfilial" v-bind:disabled="ativadesativa || vidtodasfil" data-allow-clear="true" style="width:100%;">
								</select>
							</div>
                            <div class="col-2" style="padding-top: 25px;" v-if="clonar">
                                <div class="custom-control custom-switch" style="position: absolute; left: 15px;">
                                    <input type="checkbox" class="custom-control-input" id="swselecionatodastb" 
                                    name="swselecionatodastb" v-model="vidtodasfil" v-bind:disabled="ativadesativa"
                                    @change="mtdselecionatodasfiliais()">
                                    <label class="custom-control-label" for="swselecionatodastb" title="A ação será aplicada em todas as tabelas!">
                                        Todas filiais <i class="fa fa-circle-info" data-toggle="tooltip" data-placement="right" title="Um pedido idêntico será gerado para cada filial."></i>
                                    </label>
                                </div>                            
                            </div>                           
                            <div class="col-md-3":class="clonar? 'col-md-2' : 'col-md-3'">
                                <span class="lblselect2">*Fornecedor:</span>
                                <select id="cbfornecedor" data-placeholder="Selecione um fornecedor" data-allow-clear="true"
                                        style="width:100%;" v-model="vidfornecedor" v-bind:disabled="ativadesativa">
                                </select>
                            </div>                 
							<div class="col-sm-12 col-md-2 col-lg-2">
								<label for="eddtemissao">*Dt. Emissão:</label>
								<div class="input-group">
									<date-picker id="eddtemissao" v-model="vdtemissao" :config="options"
										class="form-control form-control-sm" v-bind:disabled="ativadesativa"></date-picker>
									<div class="input-group-append">
										<span class="input-group-text"><i class="fa fa-calendar"></i></span>
									</div>										
								</div>
							</div>
							<div class="col-sm-12 col-md-2 col-lg-2">
								<label for="eddtentrega">*Dt. Entrega:</label>
								<div class="input-group">
									<date-picker id="eddtentrega" v-model="vdtentrega" :config="options"
										class="form-control form-control-sm" v-bind:disabled="ativadesativa"></date-picker>
									<div class="input-group-append">
										<span class="input-group-text"><i class="fa fa-calendar"></i></span>
									</div>										
								</div>
							</div>                            
                        </div>    
                        <div class="row" style="margin-top: 10px;">
                            <div class="col-md-12">
                                <ul class="nav nav-tabs" role="tablist">
                                    <li class="nav-item">
                                        <a class="nav-link active" data-toggle="tab" href="#dvitens">Itens do pedido</a>
                                    </li>		
                                    <li class="nav-item">
                                        <a class="nav-link" data-toggle="tab" href="#dvparcelas">Parcelas</a>
                                    </li>																		
                                    <li class="nav-item">
                                        <a class="nav-link" data-toggle="tab" href="#dvobservacoes">Observações</a>
                                    </li>                                    
                                </ul>
                                <div class="tab-content border-left border-right border-bottom" style="padding-top: 15px; padding-bottom: 15px;">
                                    <div id="dvitens" class="container-fluid tab-pane active">
                                        <div v-show="parseInt(this.opcrud) < 3" class="row">
                                            <div class="col-sm-12 col-md-4 col-lg-2">
                                                <label for="edidprodutoedicao">*Produto:</label>
                                                <div class="input-group" style="z-index: 1;">
                                                    <input type="text" class="form-control form-control-sm" id="edidprodutoedicao" v-model="vcoddigedicao" maxlength="20" v-on:blur="mtdlocalizarproduto(vcoddigedicao)" v-on:keyup.13="mtdlocalizarproduto(vcoddigedicao)" style="text-transform: uppercase;">
                                                    <div class="input-group-append">
                                                        <a href="#" class="btn btn-info btn-sm btn-grupo-pesq" role="button" @click.prevent="mtdconsultarproduto()"><i class="fa fa-search" style="padding-top: 3px;"></i></a>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-sm-12 col-md-6 col-lg-5">
                                                <label for="eddescricaoprodutoedicao">Descrição do produto:</label>
                                                <input type="text" class="form-control form-control-sm" id="eddescricaoprodutoedicao" v-model="vdescricaoprodutoedicao" maxlength="100" style="font-weight: bold; text-transform: uppercase;" >
                                            </div>
                                            <div class="col-sm-12 col-md-3 col-lg-1">
                                                <label for="edundprodutoedicao">Und:</label>
                                                <input type="text" class="form-control form-control-sm" id="edundprodutoedicao" v-model="vundprodutoedicao" data-bv-group=".group" maxlength="2" disabled style="font-weight: bold;"/>
                                            </div>
                                            <div class="col-sm-12 col-md-3 col-lg-2">
                                                <label for="edqtditemedicao">*Qtd:</label>
                                                <money type="text" class="form-control form-control-sm" id="edqtditemedicao" v-model="vqtditemedicao" data-bv-group=".group" maxlength="20" style="text-align:right;"></money>
                                            </div>
                                            <div class="col-md-2 col-lg-2">
                                                <label for="edvlunitarioitemedicao">*Valor:</label>
                                                <money type="text" class="form-control form-control-sm" id="edvlunitarioitemedicao" v-model="vvlunitarioedicao" v-bind="money" data-bv-group=".group" maxlength="20" style="text-align: right;"></money>
                                            </div>  
                                            <div class="col-sm-12 col-md-3 col-lg-3">
                                                <span class="lblselect2">*Marca:</span>
                                                <select id="cbmarca" data-placeholder="Selecione uma marca" v-model="vidmarca" v-bind:disabled="ativadesativa" data-allow-clear="true" style="width:100%;">
                                                </select>
                                            </div>
                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                <span class="lblselect2">*Grupo:</span>
                                                <select id="cbgrupo" data-placeholder="Selecione um grupo" v-model="vidgrupo" v-bind:disabled="ativadesativa" data-allow-clear="true" style="width:100%;">
                                                </select>
                                            </div>
                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                <span class="lblselect2">*Setor:</span>
                                                <select id="cbsetor" data-placeholder="Selecione um setor" v-model="vidsetor" v-bind:disabled="ativadesativa" data-allow-clear="true" style="width:100%;">
                                                </select>
                                            </div>
                                            <div class="col-md-3">
                                                <label for="edtotalitemedicao">Total:</label>
                                                <money type="text" class="form-control form-control-sm" id="edtotalitemedicao" v-model="vtotalitemedicao" v-bind="money" data-bv-group=".group" maxlength="20" style="text-align: right;" disabled></money>
                                            </div>                                                                                      
										
                
                                            <div style="padding-top: 22px" class="col-sm-12 col-md-2 col-lg-2">
                                                <button type="button" class="btn btn-primary btn-sm btn-block" @click.prevent="mtdadicionaritem()" style="width: 100%;"><i class="fa fa-plus"></i> Incluir</button>
                                            </div>                                                                                          
                                        </div>
                                        <div class="row">                                            
                                            <div class="col-md-12" style="margin-top: 10px;">
                                                <vue-bootstrap4-table
                                                        :rows="lstitenspedido"
                                                        :columns="columnsitens"
                                                        :config="configitens"
                                                        :classes="classes">
                                                    <template slot="empty-results">
                                                        <div class="col-md-12 text-center">Sem dados para visualização</div>
                                                    </template>
                                                    <!-- ícones de oradenação da table -->
                                                    <template slot="sort-asc-icon">
                                                        <i class="fa-icones-ordenacao fa fa-sort-asc"></i>
                                                    </template>
                                                    <template slot="sort-desc-icon">
                                                        <i class="fa-icones-ordenacao fa fa-sort-desc"></i>
                                                    </template>
                                                    <template slot="no-sort-icon">
                                                        <i class="fa-icones-ordenacao fa fa-unsorted"></i>
                                                    </template>                                    
                                                    <!--  -->                                    
                                                    <template slot="slot_idproduto" slot-scope="item">
                                                        {{ item.row.idproduto }}
                                                    </template>
                                                    <template slot="slot_vlunitario" slot-scope="item">
                                                        {{ mtdformatavalordecimal(parseFloat(item.row.vlunitario), 2) }}
                                                    </template>
                                                    <template slot="slot_totalitem" slot-scope="item">
                                                        <strong>{{ mtdformatavalordecimal(parseFloat(item.row.totalitem), 2) }}</strong>
                                                    </template>                                                                                                        
                                                    <template slot="opcoes" slot-scope="item">
                                                        <button type="button" class="btn btn-primary btn-sm btn-opcrud ajt-btn" @click.prevent="mtdalteraritem(item.row)"><i class="fa fa-edit"></i></button>
                                                        <button type="button" class="btn btn-danger btn-sm btn-opcrud ajt-btn" @click.prevent="mtdexcluiritem(item.row)"><i class="fa fa-trash"></i></button>
                                                    </template>
                                                </vue-bootstrap4-table>
                                            </div>
                                            <div class="col-md-6">
                                            </div>
                                            <div class="col-md-3">
                                                <input type="file" id="btselecionararquivo" accept=".xls" style="display: none;">
                                                <button type="button" @click.prevent="mtdarquivopedidocompra()" class="btn btn-primary btn-sm btn-block"
                                                        v-bind:disabled="parseInt(opcrud) === 3"><i class="fa fa-file"></i> Selecionar arquivo
                                                </button>
                                            </div>
											<div class="col-md-3">
												<button v-show="parseInt(this.opcrud) < 3" type="button" class="btn btn-primary btn-sm btn-block" @click.prevent="mtdimportaritenscoletor()"><i class="fa fa-arrow-circle-o-down"></i> Importar itens do coletor</button>
											</div>                                                                                                                                       
                                        </div>
                                    </div>
                                    <!-- dv parcelas -->
                                    <div id="dvparcelas" class="container-fluid tab-pane">
										<div class="row">
                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                <label for="eddtentregafaturamento">Dt. faturamento:</label>
                                                <div class="input-group">
                                                    <date-picker id="eddtentregafaturamento" v-model="vdfaturamento" :config="options"   v-bind:disabled="opcrud==3"
                                                        class="form-control form-control-sm" style="font-weight: bold;"></date-picker>
                                                    <div class="input-group-append">
                                                        <span class="input-group-text"><i class="fa fa-calendar"></i></span>
                                                    </div>																			
                                                </div>
                                            </div>
                                            <div class="col-sm-12 col-md-1 col-lg-1">
                                                <label for="edqtdparc">Intervalo:</label>
                                                <input type="number" class="form-control form-control-sm" id="edintervalo" 
                                                style="text-align: center; font-weight: bold;"
                                                v-model="vintervalo" data-bv-group=".group" maxlength="11" min="1"  v-bind:disabled="opcrud==3">
                                            </div> 
                                            <div class="col-sm-12 col-md-1 col-lg-1">
                                                <label for="edqtdparc">Parcelas:</label>
                                                <input type="number" class="form-control form-control-sm" id="edqtdparc" 
                                                style="text-align: center; font-weight: bold;"
                                                v-model="vqtdparc" data-bv-group=".group" maxlength="11" min="1" max="100"  v-bind:disabled="opcrud==3">
                                            </div> 
                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                <label for="eddiasparc">Dias p/ 1ª Parcela:</label>
                                                <input type="number" class="form-control form-control-sm" @blur="mtdgerardiaspri()" id="eddiasparc" 
                                                style="text-align: center; font-weight: bold;"
                                                v-model="vdiaspri" data-bv-group=".group" maxlength="11" min="1"  v-bind:disabled="opcrud==3">
                                            </div> 
                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                <label for="eddtpriparc">Data 1ª Parcela:</label>
                                                <div class="input-group">
                                                    <date-picker id="eddtpriparc" v-model="vdtpriparc" :config="options"   v-bind:disabled="opcrud==3"
                                                        class="form-control form-control-sm" style="font-weight: bold;"></date-picker>
                                                    <div class="input-group-append">
                                                        <span class="input-group-text"><i class="fa fa-calendar"></i></span>
                                                    </div>																			
                                                </div>
                                            </div>
                                            <div class="col-md-2 col-lg-2">
                                                <label for="edvlembarque">Vl. total embarque:</label>
                                                <money type="text" class="form-control form-control-sm" id="edvlembarque" v-model="vvlembarque" v-bind="money" data-bv-group=".group" maxlength="20" style="text-align: right;"></money>
                                            </div> 
                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                <label for="eddtentregaembarque">Dt. embarque:</label>
                                                <div class="input-group">
                                                    <date-picker id="eddtentregaembarque" v-model="vdtembarque" :config="options"   v-bind:disabled="opcrud==3"
                                                        class="form-control form-control-sm" style="font-weight: bold;"></date-picker>
                                                    <div class="input-group-append">
                                                        <span class="input-group-text"><i class="fa fa-calendar"></i></span>
                                                    </div>																			
                                                </div>
                                            </div>  
                                           
                                            <div style="padding-top: 20px;" class="col-10">
											
											</div>    
                                            <div style="padding-top: 20px;" class="col-2">
												<button v-show="parseInt(this.opcrud) < 3" type="button" class="btn btn-primary btn-sm btn-block" @click.prevent="mtdparcelaspagamento()"><i class="fa fa-arrow-circle-o-down"></i> Gerar</button>
											</div>         							
										</div>      
                                        <div style="padding-top: 30px;" class="row">
                                            <div class="col-12">
                                                <!-- table aqui -->
                                                <table class="table">
                                                    <tbody>
                                                      
                                                        <tr v-for="(parcela, index) in lstparcelas" :key="index">
                                                            <td>{{ parcela.codtit }}</td>
                                                            <td>{{ parcela.dtventit }}</td>
                                                            <td>{{ mtdformatavalordecimal(parcela.vltit, 2) }}</td>
                                                            <td>
                                                                <button @click.prevent="mtdeditarparcela(parcela)" class="btn btn-primary btn-sm"><i class="fa fa-edit"></i></button>
                                                            </td>
                                                        </tr>
                                                        <tr v-if="lstparcelas.length > 0">
                                                            <td colspan="3">
                                                            </td>
                                                            <td colspan="1" style="width: 150px;">
                                                                <button @click.prevent="lstparcelas = []" class="btn btn-secondary btn-sm btn-block">Limpar todos</button>
                                                            </td>
                                                        </tr>
                                                    
                                                    </tbody>
                                                </table>
                                            </div>		
                                        </div> 
                                        <div v-if="lstembarques.length > 1" style="padding-right: 200px; padding-left: 200px;" class="row">
                                            <div class="col-12">
                                                <ul class="list-group">
                                                    <a class="list-group-item text-center tit-list-group-item font-weight-bold text-black-50" style="color: #cccccc!important; background-color: #343a40; padding: 5px;">TOTAIS POR EMBARQUES</a>
                                                     <!-- table aqui -->
                                                    <table class="table">
                                                        <tbody>
                                                            <tr v-for="(embarque, index) in lstembarques" :key="index">
                                                                <td>{{ embarque.emb }}</td>
                                                                <td>{{ embarque.dtentrega }}</td>
                                                                <td style="text-align: right;">{{ mtdformatavalordecimal(embarque.total, 2) }}</td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </ul>
                                            </div>		
                                        </div>                                  
                                    </div>  
                                    <div id="dvobservacoes" class="container-fluid tab-pane">
										<div class="row">
                                            <div class="col-sm-12">
                                                <textarea class="form-control center" rows="5" id="txtobservacoes" v-model="vobservacoes" v-bind:disabled="ativadesativa"></textarea>
                                            </div>											
										</div>                                        
                                    </div>                                                                            
                                </div>                                                                    
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-3">
                                <label for="edsolicitante">*Solicitante:</label>
                                <input type="text" class="form-control form-control-sm" id="edsolicitante" v-model="vsolicitante" maxlength="50" v-bind:disabled="ativadesativa">                                                
                            </div>                                          
                            <div class="col-md-3">
                                <label for="edcondicoespagamento">*Condições de pagamento:</label>
                                <input type="text" class="form-control form-control-sm" id="edcondicoespagamento" v-model="vcondicoespagamento" maxlength="100" v-bind:disabled="ativadesativa">                                                
                            </div>      
                            <div class="col-md-2">
                                <label for="edpedidofor">Nr. Pedido (fornecedor):</label>
                                <input type="text" class="form-control form-control-sm" id="edpedidofor" v-model="vnrpedidofor"/>
                            </div>         
							<div class="col-md-2">
								<label for="cbimprimirvalores">Imprimir valores:</label>
								<select class="form-control form-control-sm" id="cbimprimirvalores" v-model="vimprimirvalores" v-bind:disabled="ativadesativa">
									<option value="0">Não</option>
									<option value="1">Sim</option>
								</select>
							</div>                                          
							<div class="col-md-2">
								<label for="cbsituacao">Situação:</label>
								<select class="form-control form-control-sm" id="cbsituacao" v-model="vsituacao" v-bind:disabled="ativadesativa">
									<option value="0">Em digitação</option>
									<option value="1">Aguardando</option>
                                    <option v-if="mtdvisualiza('010Z.005Z.035Z')" value="2">Entregue</option>
                                    <option value="3">Cancelado</option>
								</select>
							</div>                                            
                        </div>
                        <div class="row">
                            <div class="col-md-12" style="margin-top: 10px;">
                                <ul class="list-group">
                                    <li class="list-group-item d-flex justify-content-between align-items-center" style="padding: 10px;">
                                        <strong style="color: #545b62;">Total do pedido</strong>
                                        <span class="badge badge-info badge-pill text-right bdg-qtd-reg-info" style="width: 150px!important;">{{ mtdformatavalordecimal(vtotalpedido, 2) }}</span>
                                    </li>
                                </ul>
                            </div>                            
                        </div>
                    </div>
                    <div class="card-footer">
                        <div class="row">
                            <div class="col-sm-8">
                                <h5 style="font-size: 16px; color: #545b62; margin-top: 5px;"><strong>Campos com asterisco(*) devem ser informados</strong>.</h5>
                            </div>
                            <div class="col-sm-2">
                                <button id="btgravar" v-if="(opcrud == 1)" type="button" @click.prevent="mtdgravar()"
                                        v-bind:disabled="validou" class="btn btn-primary btn-sm"
                                        style="width:100%; margin-bottom:10px;"><i class="fa fa-check"></i> Gravar
                                </button>
                                <button id="btgravar" v-else-if="(opcrud == 2)" type="button" @click.prevent="mtdgravar()"
                                        v-bind:disabled="validou" class="btn btn-primary btn-sm"
                                        style="width:100%; margin-bottom:10px;"><i class="fa fa-check"></i> Alterar
                                </button>
                                <button id="btgravar" v-else-if="(opcrud == 3)" type="button" @click.prevent="mtdgravar()"
                                        v-bind:disabled="validou" class="btn btn-primary btn-sm"
                                        style="width:100%; margin-bottom:10px;"><i class="fa fa-check"></i> Excluir
                                </button>
                            </div>
                            <div class="col-sm-2">
                                <button type="button" @click.prevent="mtdcancelaredicao()" class="btn btn-secondary btn-sm" style="width:100%">
                                    <i class="fa fa-close"></i> Cancelar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Alteração do item -->
        <div class="modal fade" id="mdealteraitem" tabindex="-1" role="dialog" aria-labelledby="mdalteraitem" aria-hidden="true">
            <div class="modal-dialog modal-sm modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel" style="font-size: 14px;"><i class="fa fa-edit"></i> Alteração do item: {{ mtdformatarzeros(vitemalt.item, 3) }}</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-md-12">
                                <label for="edqtditemalt">*Qtd.:</label>
                                <money type="text" class="form-control form-control-sm" id="edqtditemalt" v-model="vqtditemalt" v-bind="money" data-bv-group=".group" style="text-align: right;"></money>
                            </div>                              
                            <div class="col-md-12">
                                <label for="edvlunitarioitemalt">*Vl. Unitário:</label>
                                <money type="text" class="form-control form-control-sm" id="edvlunitarioitemalt" v-model="vvlunitarioalt" v-bind="money" data-bv-group=".group" style="text-align: right;"></money>
                            </div>       
                            <div class="col-md-12">
                                <label for="edvltotalitemalt">Total do item:</label>
                                <money type="text" class="form-control form-control-sm" id="edvltotalitemalt" v-model="vtotalitemalt" v-bind="money" data-bv-group=".group" style="text-align: right;" disabled></money>
                            </div>
                            <div class="col-md-12">
                                <label for="cbmarcaalt">*Marca:</label>
                                <select id="cbmarcaalt" data-placeholder="Selecione uma marca" v-model="vidmarcaalt" data-allow-clear="true" data-bv-group=".group"  style="text-align: right;">
                                </select>
                            </div>       
                            <div class="col-md-12">
                                <label for="cbgrupoalt">*Grupo:</label>
                                <select id="cbgrupoalt" data-placeholder="Selecione um grupo" v-model="vidgrupoalt"  data-allow-clear="true" data-bv-group=".group"  style="text-align: right;">
                                </select>
                            </div> 
                            <div class="col-md-12">
                                <label for="cbsetoralt">*Setor:</label>
                                <select id="cbsetoralt" data-placeholder="Selecione um setor" v-model="vidsetoralt"  data-allow-clear="true" data-bv-group=".group"  style="text-align: right;">
                                </select>
                            </div>                                                                     
                        </div>
                    </div>
                    <div class="modal-footer">
                        <a href="#" class="btn btn-primary btn-sm" role="button" @click.prevent="mtdconfirmaralteracao()"><i class="fa fa-check"></i> Confirmar</a>
                        <a href="#" class="btn btn-secondary btn-sm" role="button" data-dismiss="modal"><i class="fa fa-close"></i> Cancelar</a>
                    </div>
                </div>
            </div>
        </div>

        <!-- modal alteração parcela -->
        <div class="modal" id="mdalterarparcela" tabindex="-1" role="dialog">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Alterando parcela {{legparcela.codtit}}</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <!-- conteudo -->
                        <div class="container">
                            <div class="row">
                                <div class="col-7">
                                    <label for="edvltitalt">*Valor:</label>
                                    <money type="text" class="form-control form-control-sm" id="edvltitalt" v-model="vvalortitalt" v-bind="money" data-bv-group=".group" style="text-align: right;"></money>
                                </div> 
                                <div class="col-5">
                                    <label for="eddtvenalt">Data vencimento:</label>
                                    <div class="input-group">
                                        <date-picker id="eddtvenalt" v-model="vdtventitalt" :config="options" 
                                            class="form-control form-control-sm" style="font-weight: bold;"></date-picker>
                                        <div class="input-group-append">
                                            <span class="input-group-text"><i class="fa fa-calendar"></i></span>
                                        </div>																			
                                    </div>
                                </div> 
                                <div class="col-6 " style="padding-top: 15px;">
                                   
                                </div>
                                <div class="col-6 " style="padding-top: 15px;">
                                    <div class="custom-control custom-switch" >
                                        <input type="checkbox" class="custom-control-input" id="cbabatedir" v-model="abatevalor" >
                                        <label class="custom-control-label" for="cbabatedir" id="cbabatedir" >Abater demais parcelas</label>
                                    </div>
                                </div>
                            </div> 
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-primary btn-sm"  @click.prevent="mtdconfirmaralteracaoparcela()">Confirma</button>
                        <button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal">Fechar</button>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal fade" id="mdlarquivospedido">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title"><i class="fa fa-files-o"></i> Arquivos do pedido: {{legpedidoarq.id}}, - {{ legpedidoarq.fantasia }} </h4>
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-md-12" style="margin-top: 10px;">
                                <div class="card">
                                    <div class="card-body" style="padding: 2px; min-height: 40px;">
                                        <div class="row text-center" style="padding: 15px;">
                                            <div v-for="arquivo in lstarquivospedido" class="col-md-4 dv-arq-lista">
                                                <div class="row">
                                                    <div class="col-md-12">
                                                        <a v-bind:href="'https://'+$store.state.usuario.adrsrv+'/'+arquivo.patharquivo" target="_blank">
                                                            <i v-if="extensaocxalta(arquivo.arquivo) === 'JPG' || extensaocxalta(arquivo.arquivo) === 'JPEG'" class="fa fa-file-image-o icone-arquivo" data-toggle="tooltip" v-bind:title="arquivo.arquivo"></i>
                                                            <i v-else-if="extensaocxalta(arquivo.arquivo) === 'PDF'" class="fa fa-file-pdf-o icone-arquivo" data-toggle="tooltip" v-bind:title="arquivo.arquivo"></i>
                                                            <i v-else-if="extensaocxalta(arquivo.arquivo) === 'DOC' || extensaocxalta(arquivo.arquivo) === 'DOCX'" class="fa fa-file-word-o icone-arquivo" data-toggle="tooltip" v-bind:title="arquivo.arquivo"></i>
                                                            <i v-else-if="extensaocxalta(arquivo.arquivo) === 'XLS' || extensaocxalta(arquivo.arquivo) === 'XLSX'" class="fa fa-file-excel-o icone-arquivo" data-toggle="tooltip" v-bind:title="arquivo.arquivo"></i>
                                                            <i v-else-if="extensaocxalta(arquivo.arquivo) === 'PPT' || extensaocxalta(arquivo.arquivo) === 'PPTX'" class="fa fa-file-powerpoint-o icone-arquivo" data-toggle="tooltip" v-bind:title="arquivo.arquivo"></i>
                                                            <i v-else-if="extensaocxalta(arquivo.arquivo) === 'TXT'" class="fa fa-file-text-o icone-arquivo" data-toggle="tooltip" v-bind:title="arquivo.arquivo"></i>
                                                            <i v-else-if="extensaocxalta(arquivo.arquivo) === 'ZIP' || extensaocxalta(arquivo.arquivo) === 'RAR'" class="fa fa-file-archive-o icone-arquivo" data-toggle="tooltip" v-bind:title="arquivo.arquivo"></i>
                                                            <i v-else-if="extensaocxalta(arquivo.arquivo) === 'MP3'" class="fa fa-file-audio-o icone-arquivo" data-toggle="tooltip" v-bind:title="arquivo.arquivo"></i>
                                                            <i v-else-if="extensaocxalta(arquivo.arquivo) === 'MP4' || extensaocxalta(arquivo.arquivo) === 'AVI'" class="fa fa-file-video-o icone-arquivo" data-toggle="tooltip" v-bind:title="arquivo.arquivo"></i>
                                                            <i v-else-if="extensaocxalta(arquivo.arquivo) === 'HTML'|| extensaocxalta(arquivo.arquivo) === 'HTM'" class="fa fa-file-code-o icone-arquivo" data-toggle="tooltip" v-bind:title="arquivo.arquivo"></i>
                                                            <i v-else-if="extensaocxalta(arquivo.arquivo) === 'CSS'" class="fa fa-css3 icone-arquivo" data-toggle="tooltip" v-bind:title="arquivo.arquivo"></i>
                                                            <i v-else-if="extensaocxalta(arquivo.arquivo) === 'JS'"  class="fa fa-file-code-o icone-arquivo" data-toggle="tooltip" v-bind:title="arquivo.arquivo"></i>
                                                            <i v-else-if="extensaocxalta(arquivo.arquivo) === 'PHP'" class="fa fa-file-code-o icone-arquivo" data-toggle="tooltip" v-bind:title="arquivo.arquivo"></i>
                                                            <i v-else-if="extensaocxalta(arquivo.arquivo) === 'SQL'" class="fa fa-database icone-arquivo" data-toggle="tooltip" v-bind:title="arquivo.arquivo"></i>
                                                            <i v-else-if="extensaocxalta(arquivo.arquivo) === 'CSV'" class="fa fa-file-text-o icone-arquivo" data-toggle="tooltip" v-bind:title="arquivo.arquivo"></i>
                                                            <i v-else-if="extensaocxalta(arquivo.arquivo) === 'XML'" class="fa fa-file-code-o icone-arquivo" data-toggle="tooltip" v-bind:title="arquivo.arquivo"></i>
                                                            <i v-else-if="extensaocxalta(arquivo.arquivo) === 'GIF'" class="fa fa-file-image-o icone-arquivo" data-toggle="tooltip" v-bind:title="arquivo.arquivo"></i>
                                                            <i v-else-if="extensaocxalta(arquivo.arquivo) === 'PNG'" class="fa fa-file-image-o icone-arquivo" data-toggle="tooltip" v-bind:title="arquivo.arquivo"></i>
                                                            <i v-else-if="extensaocxalta(arquivo.arquivo) === 'BMP'" class="fa fa-file-image-o icone-arquivo" data-toggle="tooltip" v-bind:title="arquivo.arquivo"></i>
                                                            <i v-else class="fa fa-file-o icone-arquivo" data-toggle="tooltip" v-bind:title="arquivo.arquivo"></i>
                                                            <i class="fa fa-close icon-del-arquivo" @click.prevent="mtdexcluirarquivo(arquivo.patharquivo)"></i>
                                                        </a>
                                                    </div>
                                                    <div class="col-md-12">
                                                        <a class="link-arquivo" v-bind:href="'https://'+$store.state.usuario.adrsrv+'/'+arquivo.patharquivo" target="_blank"><h6 class="tit-arquivo">{{ arquivo.arquivo }}</h6></a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>                                         
                            <div  class="col-md-12 text-center" style="margin-top: 15px;">
                                <input
                                    type="file" 
                                    id="ipselecionarimg"
                                   
                                    @change="mtdselecionararquivoped" 
                                    style="display: none;"
                                    ref="filesped">
                                <button type="button" @click="$refs.filesped.click()" class="btn btn-primary btn-sm"><i class="fa fa-picture-o"></i> Adicionar arquivo</button>
                            </div>                              
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal"><i class="fa fa-close"></i> Cancelar</button>
                    </div>            
                </div>
            </div>
        </div>
        <div class="modal fade" id="mdmenupedido">
			<div class="modal-dialog modal-sm modal-dialog-centered">
			<div class="modal-content">
				<div class="modal-body">
					<div class="row">
						<div class="col-md-12">
							<ul class="list-group" style="cursor: pointer;">
								<li class="list-group-item font-weight-bold text-center active" style="font-size: 18px;">{{ mtdformatarzeros(pedidomenu.id, 8) }}</li>
								<li class="list-group-item list-group-item-action font-weight-bold" style="color: #6c757d;" @click.prevent="mtdalterar(pedidomenu)"><i class="fa fa-edit"></i> ALTERAR</li>
								<li class="list-group-item list-group-item-action font-weight-bold" style="color: #6c757d;" @click.prevent="mtdexcluir(pedidomenu)"><i class="fa fa-trash"></i> EXCLUIR</li>
								<li class="list-group-item list-group-item-action font-weight-bold" style="color: #6c757d;" @click.prevent="mtdimprimirpedidocompra(pedidomenu.id)"><i class="fa fa-print"></i> IMPRIMIR</li>
								<li class="list-group-item list-group-item-action font-weight-bold" style="color: #6c757d;" @click.prevent="mtdarquivospedido(pedidomenu)"><i class="fa fa-file"></i> ARQUIVOS</li>
								<li class="list-group-item list-group-item-action font-weight-bold" style="color: #6c757d;" @click.prevent="mtdclonar(pedidomenu)"><i class="fa fa-clone"></i> CLONAR</li>	
							</ul>
						</div>
					</div>
				</div>
				<div class="modal-footer" style="padding: 5px;">
					<div class="container-fluid">
						<div class="row">
							<div class="col-md-12 text-center">
								<button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal" style="width: 150px;"><i class="fa fa-close"></i> Cancelar</button>
							</div>
						</div>					
					</div>
				</div>				        
			</div>
			</div>
		</div>

    </div>
</template>
<script>
    import BreadCrumb from '../components/cmpbreadcrumb.vue'
    import ConsultarProdutos from '../components/cmpconsultarprodutos.vue'
    import Consultanotafor from '../components/cmpconsultanotasfor.vue'
    import Graficodoughnut from '../components/cmpgraficodoughnut.vue'
    import Graficohalfdonut from '../components/cmpgraficohalfdonut.vue'
    import Graficotreemap from '../components/cmpgraficotreemap.vue'
    import Graficobarra from '../components/cmpgraficobarralateral.vue'
    import VueBootstrap4Table from 'vue-bootstrap4-table'
    import vPagination from 'vue-plain-pagination'
    import GraficoLine from '../components/cmpgraficolinecat.vue';
    import util from '../utilitarios/util.js'

    export default {
        name: 'cadpedidoscompra',
        components:{
            VueBootstrap4Table,
            vPagination,
            'breadcrumb'        : BreadCrumb,
            'consultaprodutos'  : ConsultarProdutos,
            'consultanotafor'   : Consultanotafor,
            'graficohalfdonut'  : Graficohalfdonut,
            'graficotreemap'    : Graficotreemap,
            'graficobarra'      : Graficobarra,
            'graficodoughnut'   : Graficodoughnut,
            'graficoline'   : GraficoLine
        },
        data: function() {
            return {
                utodasfiliais 		: this.$store.state.usuario.todasfiliais,
                //variaveis da consulta de produtos
				vshowprtabela			: false,//oculta a visualização do preço do produto na listagem
				vidtabela				: 1,//informo somente pq o componente exige
                tipopropesquisa         : '',

                lstpedido  : [],
                pid          : '', 
                pidfilial    : null,     
                pidfornecedor: null,
				pfiltroperiodo      : 1,
                pfiltropor          : 0,
				pdtini       		: util.DataAtual(true),
                pdtfim       		: util.DataAtual(true),
                psituacao           : 4,                
                pqtdregistros: 10,
                pqtd_paginas : 1,
                pagina_atual : 1,
                pqtd_total_registros: 0,
                vtppesqu     : 0,

                //variáveis do crud
                opcrud              :  0,
                vid                 : '',
                vidfilial           : null,
                vidfornecedor       : null,
                vdtemissao			: util.DataAtual(true),
                vdtentrega			: util.DataAtual(true), 
                vcondicoespagamento     : '',               
                vobservacoes            : '',
                vsolicitante            : '',
                vtotalpedido            : 0,
                vimprimirvalores        : 0,
                vsituacao               : 0,    
                lstitenspedido          : [],
                presumoped              : false,
                vnrpedidofor            : '',  
                lstembarques            : [],
                
                

                /// modal titulo arquivos
                legpedidoarq            : [], 
                lstarquivospedido       : [], 
                vpatharquivosped        : '',

                clonar					: false,
                vidtodasfil             : false,
                todasfiliais            : [],
                lstidfilial             : [],
                
                //variavel de impressao
                detalharfilial          : 0,
                detalharfilialimpmarca  : 0,

                //variaveis do embarque
                                                
                vqtdparc               : 1,
                vintervalo             : 30,
                vdtpriparc             : util.DataAtual(true),
                lstparcelas            : [], 
                vdiaspri               : 1,
                vvlembarque            : 0,
                vdtembarque            : util.DataAtual(true),
                vdfaturamento          : util.DataAtual(true), 

                //variaveis alteração da parcela
                
                vdtventitalt           : util.DataAtual(true),
                vvalortitalt           : 0,
                legparcela             : [],
                abatevalor             : false, 


                //variaveis da permissao da vinculação vhabrelacaopedcompra
                vhabrelacaopedcompra    : false,

                //variaveis de edicao do item
                vitem                       : 0,
				vidprodutoedicao    		: '',
				vcoddigedicao				: '',
				vdescricaoprodutoedicao 	: '',
				vundprodutoedicao			: '',
				vqtditemedicao				: 1,
				vfracionadoedicao			: 0,
				vreferenciaedicao  		    : '',
                vvlunitarioedicao           : 0,
                vtotalitemedicao            : 0,
                
                vidgrupo                    : null,
                vidmarca                    : null,
                vidsetor                    : null,
                
                //variável para habilitação dos campos
                ativadesativa       : true,

                //variáveis da alteração do item
                vitemalt            : [],
                vqtditemalt         : 1,
                vvlunitarioalt      : 0,
                vtotalitemalt       : 0,
                vidgrupoalt         : null,
                vidmarcaalt         : null,
                vidsetoralt         : null,
                //variaveis do resumo no rodapé
                vdigitacao          : 0,
                vaguardando         : 0,
                ventregue           : 0,
                vcancelado          : 0,

                vqtddigitacao       : 0,
                vqtdaguardando      : 0,
                vqtdentregue        : 0,
                vqtdcancelado       : 0,

                //variaveis consultanota fornecedor
                vidpedidonotafor    : 0,
                vidfornecedornota   : 0,

                //variaveis agrupamento

                lstpedidosagrupados : [],


                //variaveis importação
                vnomearquivo         : '',

                // variaveis pedido cotacao
                pedidocotacao        : [],


                ///variaveis dashboard

                ppagamento          : 0,  

                //demonstrativo de setores
                dadossetorpro       : [],
                legendassetorpro    : [],  
                totalsetores        : 0,

                //demonstrativo de grupos
                dadosgrupospro      : [],
                legendasgrupospro   : [],
                totalgrupos         : 0,   


                //demonstrativos compras filial

                dadospedidosfil       : [],
                legendaspedidofil     : [],

                dadosmarca            : [],
                legendasmarca         : [],
                totalmarcas           : 0,


                dadosmeta             : [],
            
                legendasmeta          : [],
                legendasmeta          : [],


                ///previsão de recebimentos

                prevrecebimento       : [],
                seriesgraficoline     : [],
                periodograficoline    : [],
                legendagraficoline    : [],



                 ///previsão de pagamento

                prevpagamento        : [],
                seriesgraficolinepag : [],
                periodograficolinepag: [],
                legendagraficolinepag: [],

                //demonstrativo compraspagar 

                contaspagar          : [],
                seriescontaspagar    : [],
                periodocontaspagar   : [],
                legendacontaspagar   : [],
                vidcategfor          : null,



                //totalizadores
                vtotaguardando       : 0,
                vtotentregue         : 0,
                vtotcancelado        : 0,   
                vtotdigitacao        : 0,
            
                pedidomenu		    : [], //para geração do menu do pedido no modal
		
				money				: {
                    decimal         : ',',
                    thousands       : '.',
                    prefix          : '',//aqui colocar o cifrão se for necessário
                    precision       : 2,
                    masked          : false
                },
                options: {
                    format           : 'DD/MM/YYYY',
                    useCurrent       :  false,
                    locale           : 'pt-BR'
                },
                bootstrapPaginationClasses: {
                    ul: 'pagination pagination-sm',
                    li: 'page-item',
                    liActive: 'active',
                    liDisable: 'disabled',
                    button: 'page-link'
                },
                itensbc : {
                    item1 : {
                        titulo : 'PEDIDOS DE COMPRA',
                        ativo  : false
                    },
                    item2 : {
                        titulo : '',
                        ativo  : false
                    }
                },
                columns: [
                    {
                        label: 'Opções',
                        name : 'opcoes',
                        row_text_alignment: "text-center",
                        column_text_alignment: "text-center",
                        row_classes: "def-col-opcoes-compra",
                        sort: false
                    },
                    {
                        label: "Nr. pedido",
                        name: "id",
                        sort: true,
                        initial_sort : true,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',                        
                        slot_name: "id_f",
                        row_classes: "def-col-cod",
                    },
                    {
                        label: "Filial",
                        name: "fantasiafilial",
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Fornecedor",
                        name: "fantasia",
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Emissão",
                        name: "dtemissao",
                        sort: true,
                        slot_name: "slot_dtemissao",
                        row_classes: "def-col-dtemissao",
                        row_text_alignment: "text-right",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Entrega",
                        name: "dtentrega",
                        sort: true,
                        slot_name: "slot_dtentrega",
                        row_classes: "def-col-dtentrega",
                        row_text_alignment: "text-right",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Total",
                        name: "totalpedido",
                        sort: true,
                        slot_name: "slot_totalpedido",
                        row_classes: "def-col-totalpedido",
                        row_text_alignment: "text-right",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Entregue",
                        sort: true,
                        slot_name: "slot_entregue",
                        row_classes: "def-col-totalpedido",
                        row_text_alignment: "text-right",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Restante",
                        sort: true,
                        slot_name: "slot_restante",
                        row_classes: "def-col-totalpedido",
                        row_text_alignment: "text-right",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Nr. Ped for",
                        name: "nrpedidofor",
                        sort: true,
                        initial_sort : true,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',                        
                        row_classes: "def-col-cod",
                    },
                    {
                        label: "Nf. for",
                        name: "idnotafor",
                        sort: true,
                        slot_name: "slot_notafor",
                        initial_sort : true,//acrescentar isso na coluna que for iniciar ordenado
                        initial_sort_order: 'asc',                        
                        row_classes: "nrfor",
                    },
                    {
                        label: "Situação",
                        name: "situacao",
                        sort: true,
                        slot_name: "slot_situacao",
                        row_classes: "def-col-situacao",
                        row_text_alignment: "text-center",
                        column_text_alignment: "text-left"
                    }
                ],                
                config: {
                    pagination: false,
                    checkbox_rows: true,
                    pagination_info: false,
                    card_mode: false,
                    global_search: {
                        visibility: false,
                    },
                    show_refresh_button : false,
                    show_reset_button : false
                },
                configitens: {
                    pagination: false,
                    pagination_info: false,
                    card_mode: false,
                    global_search: {
                        visibility: false,
                    },
                    show_refresh_button : false,
                    show_reset_button : false
                },
                classes: {
                    table: "table-bordered table-striped table-sm"
                },
                columnsitens: [
                    {
                        label: 'Opções',
                        name : 'opcoes',
                        row_text_alignment: "text-center",
                        column_text_alignment: "text-center",
                        row_classes: "def-col-opcoes",
                        sort: false
                    },
                    {
                        label: "Item",
                        name: "item",
                        sort: true,
                        slot_name: "slot_item",
                        row_classes: "def-col-item",
                        row_text_alignment: "text-right",
                    },
                    {
                        label: "Código",
                        name: "coddig",
                        sort: true,
                        slot_name: "slot_idproduto",
                        row_classes: "def-col-idproduto",
                        row_text_alignment: "text-right",
                    },
                    {
                        label: "Descrição",
                        name: "descricao",
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Referência",
                        name: "referencia",
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Marca",
                        name: "descmarca",
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Grupo",
                        name: "descgrupo",
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Setor",
                        name: "descsetor",
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Qtd",
                        name: "qtditem",
                        sort: true,
                        row_text_alignment: "text-right",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Und",
                        name: "und",
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Pr. Compra",
                        name: "vlunitario",
                        sort: true,
                        slot_name: "slot_vlunitario",
                        row_classes: "def-col-vlunitario",
                        row_text_alignment: "text-right",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Total",
                        name: "totalitem",
                        sort: true,
                        slot_name: "slot_totalitem",
                        row_classes: "def-col-totalitem",                        
                        row_text_alignment: "text-right",
                        column_text_alignment: "text-left"
                    }
                ]
            }
        },
        methods:{
            mtdmostrarmenu(pedido){				
				this.pedidomenu = pedido;
				$('#mdmenupedido').modal('show');
			},
            mtdbaixarmatriz(){
                window.open('https://www.rillsoft-app.cloud/controller/arquivosimportacao/manager/matrizes/matrizitenspedidocompra.xls', '_blank');
            },
            mtdprocessararquivo(arquivo){
                let vself  = this;
                let loader = vself.$loading.show();
                let parametros      = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor : 'processararquivo'},
                    {parametro: 'arquivo',      valor : arquivo}
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadpedidoscompra.php');
                retorno.then(function (response) {
                    loader.hide();
                    if ($.isNumeric(response.data.status)){
                        vself.lstitenspedido = [];
                        vself.lstitenspedido = response.data.itens;
                    }else{
                        vself.lstitenspedido = [];
                        vself.$toastr.e(response.data.status, 'Erro!');
                    }
                }).catch(function (response) {
                    loader.hide();
                    vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!');
                });                
            },
            mtdrotinacpedcompra(){
                let vself = this;                
                
                let varquivo                = document.getElementById("btselecionararquivo").files[0];
                vself.vnomearquivo          = varquivo.name;

                let extarq = varquivo.name.substring(varquivo.name.lastIndexOf('.') + 1);
                if (extarq.toUpperCase() !== 'XLS'){
                    vself.$toastr.w("O arquivo selecionado não possui formato válido!", 'Atenção!');
                }else{ 
                    let loader      = vself.$loading.show();
                    let localsalvar = 'arquivos/manager/pedidoscompra/' + vself.$store.state.filialpadrao.idcliente;

                    let parametros      = [
                        {parametro: 'arquivo',          valor  : varquivo},
                        {parametro: 'localsalvar',      valor  : localsalvar},
                        {parametro: 'nomearquivo',      valor  : varquivo.name}
                    ];
                    let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/uploadfile.php');
                    retorno.then(function (response) {
                        if ($.isNumeric(response.data.inf)){
                            $('#btselecionararquivo').val('');
                            vself.mtdprocessararquivo('arquivos/manager/pedidoscompra/' + vself.$store.state.filialpadrao.idcliente+'/'+vself.vnomearquivo)
                        }else{
                            $('#btselecionararquivo').val('');
                            vself.$toastr.e('Descrição do erro: '+response.data, 'Erro!');
                        }
                        loader.hide();
                    }).catch(function (response) {
                        loader.hide();
                        vself.$toastr.e('Descrição do erro: '+response.message, 'Erro!');
                        $('#btselecionararquivo').val('');
                    });
                }
            },
            mtdarquivopedidocompra(){
                 //limpa o arquivo do input file
                 const file               = document.querySelector('#btselecionararquivo');
                file.value               = '';
                this.vnomearquivo        = '';
                ///////////////////////////////
                $('#btselecionararquivo').trigger('click');

            },
            mtdprocessacadastro(itens){
                this.itensbc.item2.titulo = 'INCLUSÃO DE PEDIDO DE COMPRA';
                this.itensbc.item1.ativo = true;
                this.itensbc.item2.ativo = true;
                this.ativadesativa = false;
                this.mtdpreparacrud(1);
                this.lstitenspedido = itens;

                for (let index = 0; index < itens.length; index++) {
                    this.vtotalpedido = this.vtotalpedido + parseFloat(itens[index].totalitem) 
                }
            },
            mtdpegaitenspedidos(agrupar){

                let vself = this;
             
                let registroped = {
                    'pedidos'                : this.lstpedidosagrupados,
                   
                };
                let parametros      = [
                    {parametro: 'idclientesac', valor : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor : 'pegaritenspedidos'},
                    {parametro: 'agrupar',      valor : agrupar === true ? 1 : 0},
                    {parametro: 'registro',     valor : JSON.stringify(registroped)},
                    {parametro: 'idfilial',     valor : vself.$store.state.filialpadrao.codfil},
                    {parametro: 'idusuario',    valor : vself.$store.state.usuario.id},
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadpedidoscompra.php');
                retorno.then(function (response) {
                    vself.mtdprocessacadastro(response.data)
                    loader.hide();
                }).catch(function (response) {
                    loader.hide();
                    vself.$toastr.e('Descrição do erro: '+response.message, 'Erro!');
                });     
            },
            mtdagrupapedidos(){
                var vself = this;

                if (this.$refs.reflstpedidos.selected_items.length === 1){
                    this.$toastr.w('Selecione os pedidos para agrupamento!', 'Atenção!');
                    return;
                }

                if (!util.opcaousuario('010Z.005Z.040Z', this.$store.state.perfilusuario)){
                    this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                    return;
                }

                this.lstpedidosagrupados = this.$refs.reflstpedidos.selected_items;


                //trazer os itens dos pedidos agrupados ou não 

                $.confirm({
                    title: 'Confirmação!',
                    content: 'Agrupar os items repetidos?',
                    icon: 'fa fa-question-circle',
                    escapeKey: true,
                    backgroundDismiss: false,
                    escapeKey: 'nao',
                    type: 'dark',
                    typeAnimated: true,
                    buttons: {
                        sim: {
                            text: '<u>S</u>im',
                            keys: ['s', 'S'],
                            btnClass: 'btn-blue',
                            action: function () {
                                $('.btn-blue').prop('disabled', true);

                                vself.mtdpegaitenspedidos(true);
                            },
                        },
                        nao: {
                            text: '<u>N</u>ão',
                            keys: ['n', 'N'],
                            action: function () {
                                
                                vself.mtdpegaitenspedidos(false);
                            }
                        }
                    }
                });

            },
            extensaocxalta(nomearquivo) {
                var partes = nomearquivo.split('.');
                if (partes.length > 1) {
                    var extensao = partes.pop();
                    return extensao.toUpperCase();
                } else {
                    return "sem_ext";
                }
            },
            mtdselecionararquivoped(event){
                let vself = this;
                let arqimgselecionado = event.target.files[0];
                let loader      = vself.$loading.show();
                let localsalvar = 'controller/arquivospedidoscompra/'+
                                  vself.$store.state.filialpadrao.idcliente + '/' + vself.vpatharquivosped;

                let parametros      = [
                    {parametro: 'arquivo',          valor  : arqimgselecionado},
                    {parametro: 'localsalvar',      valor  : localsalvar},
                    {parametro: 'nomearquivo',      valor  : arqimgselecionado.name},
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/uploadfile.php');
                retorno.then(function (response) {
                    if ($.isNumeric(response.data.inf)){
                        vself.$toastr.s('arquivo enviado com sucesso!', 'Informação!');
                        vself.lstarquivospedido = [];
                        vself.lstarquivospedido = response.data.arquivos;
                    
                        $('#ipselecionarimg').val('');

                    }else{
                        vself.$toastr.e('Descrição do erro: '+response.data, 'Erro!');
                    }
                    loader.hide();
                }).catch(function (response) {
                    loader.hide();
                    vself.$toastr.e('Descrição do erro: '+response.message, 'Erro!');
                });     
            },
            mtdexcluirarquivo(patharquivo){
                let vself = this;
                let loader       = vself.$loading.show();
                let localarquivo = 'controller/arquivospedidoscompra/'+
                                  vself.$store.state.filialpadrao.idcliente + '/' + vself.vpatharquivosped;

                let parametros      = [
                    {parametro: 'op',               valor  : "excluirarquivo"},
                    {parametro: 'patharquivo',      valor  : patharquivo},
                    {parametro: 'localarquivo',     valor  : localarquivo}
                    
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/auxiliares.php');
                retorno.then(function (response) {
                    if ($.isNumeric(response.data.inf)){
                        vself.$toastr.s('Arquivo excluído com sucesso!', 'Informação!');
                        vself.lstarquivospedido = []
                        vself.lstarquivospedido = response.data.arquivos
                    }else{                        
                        vself.$toastr.e('Descrição do erro: '+response.data, 'Erro!');
                    }
                    loader.hide();
                }).catch(function (response) {
                    loader.hide();
                    vself.$toastr.e('Descrição do erro: '+response.message, 'Erro!');
                });                  
            },
            mtdpreparamodalarq(path){
                var vself       = this;
                let loader      = vself.$loading.show();
                let patharquivos= 'controller/arquivospedidoscompra/'+
                                  vself.$store.state.filialpadrao.idcliente + '/' + path;
                let parametros  = [
                    {parametro: 'op',               valor  : 'listararquivos'},
                    {parametro: 'idclientesac',     valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'patharquivos',     valor  : patharquivos},
                ];
                let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadpedidoscompra.php');
                retorno.then(function (response) {
                    loader.hide();
                    vself.lstarquivospedido = []
                    vself.lstarquivospedido = response.data
                    vself.vpatharquivosped  = path;
                    $('#mdlarquivospedido').modal('show');
                    
                }).catch(function (response) {
                    loader.hide();
                });

            },
            mtdarquivospedido(pedido){
                $('#mdmenupedido').modal('hide');
                this.legpedidoarq = pedido;
                var vself       = this;
                let loader      = vself.$loading.show();
                let parametros  = [
                    {parametro: 'op',               valor : 'verificapath'},
                    {parametro: 'idclientesac',     valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'idpedido',         valor  : pedido.id},
                ];
                let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadpedidoscompra.php');
                retorno.then(function (response) {
                    loader.hide();
                    if ($.isNumeric(response.data.msg)){
                        vself.mtdpreparamodalarq(response.data.path)   
                    }else{
                        let tpret = response.data.msg.substring(0,1);
                        switch (tpret) {
                            case 'I':
                                vself.$toastr.w(response.data.msg.substring(4), 'Atenção!');
                                break;
                            case 'E': default:
                                vself.$toastr.e(response.data.msg.substring(4), 'Erro!');
                                break;
                        }

                    }						
                    
                }).catch(function (response) {
                    loader.hide();
                });
            },
            mtdvisualiza(oprel){                
                return util.opcaousuario(oprel, this.$store.state.perfilusuario);
            },
            mtdgerarembarque(){
                this.lstembarques = [];
            
                const embarques = {};

                this.lstparcelas.forEach(parcela => {
                    const [numeroparcela , quantasparcelas ,numeroEmbarque] = parcela.codtit.split('-');
                    
                    if (!embarques[numeroEmbarque]) {
                        embarques[numeroEmbarque] = {
                            emb: numeroEmbarque,
                            dtprimeiraparce: parcela.dtventit,
                            total: parcela.vltit
                        };
                    } else {
                        embarques[numeroEmbarque].total += parcela.vltit;
                }
                });
                this.lstembarques = Object.values(embarques);
            },
            resetadadosembarque(){
                this.vintervalo    = 30
                this.vqtdparc      = 1
                this.vdiaspri      = 1
                this.vdtpriparc    = util.DataAtual(true); 
                this.vvlembarque   = 0;
                this.vdtembarque   = util.DataAtual(true); 
                this.vdfaturamento = util.DataAtual(true);
            },
            mtdgerardiaspri(){
                if(parseInt(this.vdiaspri)<=0){
                    this.$toastr.i('Adicione uma data válida!', 'Atenção!');
                    $('#eddiasparc').focus();
                }else{

                    const partesDataEntrega = this.vdfaturamento.split('/');
                    const diaEntrega = parseInt(partesDataEntrega[0]);
                    const mesEntrega = parseInt(partesDataEntrega[1]) - 1; 
                    const anoEntrega = parseInt(partesDataEntrega[2]);


                    const dataEntrega = new Date(anoEntrega, mesEntrega, diaEntrega);

                    const diasParaPrimeiraParcela = parseInt(this.vdiaspri);

                    dataEntrega.setDate(dataEntrega.getDate() + diasParaPrimeiraParcela);

                    const dia = String(dataEntrega.getDate()).padStart(2, '0');
                    const mes = String(dataEntrega.getMonth() + 1).padStart(2, '0');
                    const ano = dataEntrega.getFullYear();


                    this.vdtpriparc = `${dia}/${mes}/${ano}`;
                }
        
            },
            mtdgeratotais(){
                setTimeout(() => {
                    let digitacao   = 0
                    let totalaguard = 0
                    let totentregue = 0
                    let cancelados  = 0
                        for (let index = 0; index < this.lstpedido.length; index++) {
                            if(parseInt(this.lstpedido[index].situacao)!==3){
                                if(parseInt(this.lstpedido[index].situacao)===0){
                                    digitacao  =  digitacao + this.lstpedido[index].totalpedido
                                }else{
                                    totentregue = totentregue + this.lstpedido[index].totentregue
                                    totalaguard = totalaguard + this.lstpedido[index].totrestante
                                }
                            }else{
                                cancelados  =  cancelados + this.lstpedido[index].totalpedido
                            }
                        }
                    this.vtotaguardando  = totalaguard
                    this.vtotcancelado   = cancelados
                    this.vtotentregue    = totentregue
                    this.vtotdigitacao   = digitacao
                    
                }, 2000);
            },
            mtdobterperiodo(data){
                let arraydata = data[0];
                const periodos = new Set();
                for (let i = 0; i < arraydata.length; i++) {
                    const filial = arraydata[i];
                    for (let j = 0; j < filial.dados.length; j++) {
                    const item = filial.dados[j];
                    periodos.add(item.periodo);
                    }
                }
                return Array.from(periodos);
            },
            mtdprocessadadosgraficolinepag(data){
                this.prevpagamento    = Object.values(data);
                this.periodograficolinepag = this.mtdobterperiodo(this.prevpagamento);
               
                // Substituir mapeamento do legendagraficoline
                this.legendagraficolinepag = [];
                for (let i = 0; i < this.prevpagamento[0].length; i++) {
                this.legendagraficolinepag.push(this.prevpagamento[0][i].descfil);
                }

                // Substituir mapeamento do seriesgraficoline
                this.seriesgraficolinepag = [];
                for (let i = 0; i < this.prevpagamento[0].length; i++) {
                const filial = this.prevpagamento[0][i];
                const seriesItem = {
                    name: filial.descfil,
                    type: 'line',
                    stack: 'Total',
                    data: []
                };

                for (let j = 0; j < this.periodograficolinepag.length; j++) {
                    const periodo = this.periodograficolinepag[j];
                    const dadosDaFilial = filial.dados.find(item => item.periodo === periodo);
                    seriesItem.data.push(dadosDaFilial ? dadosDaFilial.totalcompra : 0);
                }

                     this.seriesgraficolinepag.push(seriesItem);
                }
            },
            mtdprocessadadosgraficolinecontas(data){
                this.compraspagar          = Object.values(data);
                this.periodocontaspagar    = this.mtdobterperiodo(this.compraspagar);
               
                // Substituir mapeamento do legendagraficoline
                this.legendacontaspagar    = [];
                for (let i = 0; i < this.compraspagar[0].length; i++) {
                  this.legendacontaspagar.push(this.compraspagar[0][i].descfil);
                }

                // Substituir mapeamento do seriesgraficoline
                this.seriescontaspagar     = [];
                for (let i = 0; i < this.compraspagar[0].length; i++) {
                const filial = this.compraspagar[0][i];
                const seriesItem = {
                    name: filial.descfil,
                    type: 'line',
                    stack: 'Total',
                    data: []
                };

                for (let j = 0; j < this.periodocontaspagar.length; j++) {
                    const periodo = this.periodocontaspagar[j];
                    const dadosDaFilial = filial.dados.find(item => item.periodo === periodo);
                    seriesItem.data.push(dadosDaFilial ? dadosDaFilial.totalcompra : 0);
                }

                     this.seriescontaspagar.push(seriesItem);
                }
            },
            mtdprocessadadosgraficoline(data){
                this.prevrecebimento    = Object.values(data);
                this.periodograficoline = this.mtdobterperiodo(this.prevrecebimento);
               
                // Substituir mapeamento do legendagraficoline
                this.legendagraficoline = [];
                for (let i = 0; i < this.prevrecebimento[0].length; i++) {
                this.legendagraficoline.push(this.prevrecebimento[0][i].descfil);
                }

                // Substituir mapeamento do seriesgraficoline
                this.seriesgraficoline = [];
                for (let i = 0; i < this.prevrecebimento[0].length; i++) {
                const filial = this.prevrecebimento[0][i];
                const seriesItem = {
                    name: filial.descfil,
                    type: 'line',
                    stack: 'Total',
                    data: []
                };

                for (let j = 0; j < this.periodograficoline.length; j++) {
                    const periodo = this.periodograficoline[j];
                    const dadosDaFilial = filial.dados.find(item => item.periodo === periodo);
                    seriesItem.data.push(dadosDaFilial ? dadosDaFilial.totalcompra : 0);
                }

                    this.seriesgraficoline.push(seriesItem);
                }
            },
            mtdexecutadash(){
                var vself           = this;             
                let filtro          = vself.mtdfiltropesquisa();
                let filtrocp        = vself.mtdfiltropesquisacp();
                let parametros      = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor  : 'dashboard'},
                    {parametro: 'filtro',       valor  : filtro},
                    {parametro: 'filtrocp',     valor  : filtrocp},
                    {parametro: 'dini',         valor  : util.InverterData(vself.pdtini)},
                    {parametro: 'dfim',         valor  : util.InverterData(vself.pdtfim)}
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadpedidoscompra.php');
                retorno.then(function (response) {
                    

                    vself.dadossetorpro     = response.data.setorpro;
                    vself.legendassetorpro  = util.gerardadoslegendagrafico(vself.dadossetorpro);
                    vself.totalsetores      = vself.dadossetorpro.reduce((acc, item) => acc + parseFloat(item.value), 0);

                    vself.dadosgrupospro    = response.data.grupopro;
                    vself.legendasgrupospro = util.gerardadoslegendagrafico(vself.dadosgrupospro);
                    vself.totalgrupos       = vself.dadosgrupospro.reduce((acc, item) => acc + parseFloat(item.value), 0);

                    vself.dadospedidosfil   = response.data.comprasfil;
                    vself.legendaspedidofil = util.gerardadoslegendagrafico(vself.dadospedidosfil);

                    vself.dadosmarca        = response.data.comprasmarca;
                    vself.legendasmarca     = util.gerardadoslegendagrafico(vself.dadosmarca);
                    vself.totalmarcas       = vself.dadosmarca.reduce((acc, item) => acc + parseFloat(item.value), 0);

            
                    vself.dadosmeta = [
                        {value: parseFloat(response.data.atingida), name: 'ATINGIDA'},
                        {value: parseFloat(response.data.restante), name: 'RESTANTE'}                       
                      
                    ];
                    vself.legendasmeta = util.gerardadoslegendagrafico(vself.legendasmeta);

                    vself.mtdprocessadadosgraficoline(response.data.prevrecebimento);
                    vself.mtdprocessadadosgraficolinepag(response.data.prevpagamento);
                    vself.mtdprocessadadosgraficolinecontas(response.data.contaspagar)
                }).catch(function (response) {
                   
                });
            },
            mtdvernotasfor(pedido){
                this.vidpedidonotafor  = pedido.id;
                this.vidfornecedornota = pedido.idfornecedor;
                $("#mdnotasfor").modal('show');
            },
            mtdeditarparcela(parcela){
                this.abatevalor = false;
                this.legparcela = parcela;
                $("#mdalterarparcela").modal('show');

                this.vvalortitalt = parcela.vltit
                this.vdtventitalt = parcela.dtventit
            },
            mtdconfirmaralteracaoparcela(){
                if(this.vvalortitalt > this.vtotalpedido){
                    this.$toastr.w('O valor da parcela não pode ser maior que o total do pedido', 'Atenção!');
                    return
                }
                let totalparcelas = 0;
                //pega o indice do item que estou alterando
                let index = util.getArrayIndexForKey(this.lstparcelas, 'codtit', this.legparcela.codtit)

                if(this.abatevalor){
                    ///gera o total em parcelas
                    for (let i = 0; i < this.lstparcelas.length; i++) {
                        totalparcelas = totalparcelas + this.lstparcelas[i].vltit;
                    }
                    ///gera um total restante para poder dividir com as demais parcelas
                    let novotot          = totalparcelas -  this.vvalortitalt
                    let valorparcelarest = novotot / (this.lstparcelas.length - 1)

                    ///atualiza o valor das demais parcelas
                    for (let i = 0; i < this.lstparcelas.length; i++) {
                        if(index !== i){
                            this.lstparcelas[i].vltit = valorparcelarest;
                        }
                    }
                }
 
                //altera a parcela em questão

                this.lstparcelas[index].dtventit = this.vdtventitalt;
                this.lstparcelas[index].vltit    = this.vvalortitalt;

                this.legparcela                  = [];
                this.vvalortitalt                = util.DataAtual(true)
                this.vdtventitalt                = 0

                $("#mdalterarparcela").modal('hide');
            },
            mtdencontrarproximoembarque(arr){
                const numerosEmbarque = [];
                for (const embarque of arr) {
                    const partes = embarque.codtit.split('-');
                    const numeroEmbarque = partes[partes.length - 1];
                    numerosEmbarque.push(Number(numeroEmbarque));
                }
                const ultimoEmbarque = Math.max(...numerosEmbarque);
                return ultimoEmbarque + 1;
            },
            mtdparcelaspagamento(newVal, oldVal) {
                if (newVal !== oldVal) {
                    if (this.lstparcelas.length > 0) {
                        let totembarque     = 0;
                        let numparcelas     = this.lstparcelas.length;
                        let valorparcela    = util.arredondaValores(parseFloat(newVal) / numparcelas, 2, 'round');

                        this.lstparcelas.forEach((parcela, index) => {
                            parcela.vltit       = valorparcela;
                            parcela.dtventit    = index === 0 ? this.vdtpriparc : util.somaDias(this.mtdformatadatagravar(this.vdtpriparc), parseFloat(index * this.vintervalo));
                            totembarque += valorparcela;
                        });

                        let embarque = this.mtdencontrarproximoembarque(this.lstparcelas);

                        this.lstembarques = [
                            {
                                emb:        embarque,
                                dtentrega:  this.mtdformatadatagravar(this.vdtembarque),
                                total:      totembarque,
                            }
                        ];
                    } 
                } else {
                    if(this.vvlembarque === 0){
                        this.$toastr.w('Adicione Valor de embarque!', 'Atenção!');
                    }else{
                        let embarque    = 0
                        let totembarque = 0
                        if(this.lstparcelas.length > 0){
                            embarque = this.mtdencontrarproximoembarque(this.lstparcelas);
                        }else{
                            embarque = 1;
                        }
    
                        for (let i = 0; i < this.vqtdparc; i++) {
                            let dtventmp = i + 1 === 1 ? this.vdtpriparc : util.somaDias(this.mtdformatadatagravar(this.vdtpriparc), parseFloat(i * this.vintervalo));
                            let parctmp = {
                                'codtit' 			  : this.mtdformatarzeros(i + 1, 2) + '-'+this.vqtdparc+'-'+embarque,
                                'dtventit'			  : dtventmp,
                                'vltit'				  : util.arredondaValores(parseFloat(this.vvlembarque) / parseFloat(this.vqtdparc), 2, 'round'),
                            };
                            totembarque += parseFloat(this.vvlembarque) / parseFloat(this.vqtdparc);
    
                            this.lstparcelas.push(parctmp);
                        }
    
                        let pembarq = {
                            'emb' 			      : embarque,
                            'dtentrega'	          : this.mtdformatadatagravar(this.vdtembarque),
                            'total'				  : totembarque,
                        };
                        this.lstembarques.push(pembarq);
                        
                        this.resetadadosembarque();
                    }
                }
            },
			mtdformatavalordecimal(valor, digitos){
                if (parseFloat(valor) > 0){
				    return util.formatavalordecimais(valor, digitos);
                }else{
                    return 0;
                }
			},          
			mtdformatarzeros(str, length){ 
				return util.formatarzeros(str, length);
			},            
            mtddefiniciais(){
                let vself = this;
				let sqliniusuario = parseInt(vself.utodasfiliais) === 0 ? 'select f.codfil, f.fantasia from tbfiliaisusuario fu left join tbfiliais f on f.codfil=fu.idfilial ' : 'select codfil, fantasia from tbfiliais ';
				let sqlfimusuario = parseInt(vself.utodasfiliais) === 0 ? 'where upper(f.fantasia) like upper("%@@%") and fu.idusuario='+vself.$store.state.usuario.id 		 : 'where upper(fantasia) like upper("%@@%")';                
                $("#cbfornecedorpesq").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbfornecedores',
								c1: 'id',
								c2: 'nomerazaosocial'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 1,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
                    vself.pidfornecedor = $("#cbfornecedorpesq").val();
                    vself.mtdlimpar_listagem();
                });
                $('#btselecionararquivo').change(function() {
                    vself.mtdrotinacpedcompra();
                });    

				$("#cbfilialpesq").select2({
					id: function (e) {return e.codfil},
					ajax: {						
						url: vself.$store.state.configpaths.pathselect2sql,						
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q		: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								sqlini	: sqliniusuario,
								sqlfim	: sqlfimusuario,
								cpid	: 'codfil',
								cpdesc	: 'fantasia'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.pidfilial = $("#cbfilialpesq").val();
					vself.mtdlimpar_listagem();
				});

				$("#cbfilial").select2({
					id: function (e) {return e.codfil},
					ajax: {						
						url: vself.$store.state.configpaths.pathselect2sql,						
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q		: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								sqlini	: sqliniusuario,
								sqlfim	: sqlfimusuario,
								cpid	: 'codfil',
								cpdesc	: 'fantasia'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.vidfilial = $("#cbfilial").val();
				});

                $("#cbfornecedor").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbfornecedores',
								c1: 'id',
								c2: 'nomerazaosocial'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 1,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
                    vself.vidfornecedor = $("#cbfornecedor").val();
                });

                $("#cbmarca").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbmarcas',
								c1: 'id',
								c2: 'descricao'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
                    vself.vidmarca = $("#cbmarca").val();
                }); 

                $("#cbgrupo").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbgrupos',
								c1: 'id',
								c2: 'descricao'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
                    vself.vidgrupo = $("#cbgrupo").val();
                }); 
                $("#cbsetor").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbsetoresprodutos',
								c1: 'id',
								c2: 'descricao'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
                    vself.vidsetor = $("#cbsetor").val();
                }); 

                $("#cbsetoralt").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbsetoresprodutos',
								c1: 'id',
								c2: 'descricao'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
                    vself.vidsetoralt = $("#cbsetoralt").val();
                }); 


                $("#cbmarcaalt").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbmarcas',
								c1: 'id',
								c2: 'descricao'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
                    vself.vidmarcaalt = $("#cbmarcaalt").val();
                }); 

                $("#cbgrupoalt").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbgrupos',
								c1: 'id',
								c2: 'descricao'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
                    vself.vidgrupoalt = $("#cbgrupoalt").val();
                }); 

                $("#cbcategfor").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbcategorias',
								c1: 'id',
								c2: 'descricao'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
                    vself.vidcategfor = $("#cbcategfor").val();


                    let filtrocp        = vself.mtdfiltropesquisacp();

                    let parametros      = [
                        {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                        {parametro: 'op',           valor  : 'executadashcontaspagar'},
                        {parametro: 'categoria',    valor  : vself.vidcategfor === null ? "" : "AND fr.idcategoria="+vself.vidcategfor},
                        {parametro: 'filtrocp',     valor  : filtrocp}
                    ];
                    let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadpedidoscompra.php');
                    retorno.then(function (response) {
                        vself.mtdprocessadadosgraficolinecontas(response.data.contaspagar)
                    }).catch(function (response) {
                        alert('Erro ao consultar registros');
                    });

                }); 

				$('#mdealteraitem').on('shown.bs.modal', function (e) {
					$('#edqtditemalt').focus();
                });                               
            },
			mtdformatadatagravar(dtformatar){
				let strret = dtformatar.replace(/\D/g, "");
				return strret.substring(0,2)+'/'+strret.substring(2,4)+'/'+strret.substring(4);
			},       
            mtdfiltropesquisacp(){
                let rfiltro = '';                             
                if (this.pidfilial !== null){
                    rfiltro = rfiltro +' and t.idfilial='+this.pidfilial;
                }                
                if (this.pidfornecedor !== null){
                    rfiltro = rfiltro +' and t.idfornecedor='+this.pidfornecedor;
                }
				if(parseInt(this.pfiltroperiodo) === 1){
					rfiltro = rfiltro + ' and t.dtventit between "' + util.InverterData(this.pdtini) + '" and "' + util.InverterData(this.pdtfim) + '"';
				}                
                return rfiltro;
            },     
            mtdfiltropesquisa(){
                let rfiltro = '';
                if (this.pid !== ''){
                    if(parseInt(this.vtppesqu)===1){
                        rfiltro = ' and pc.nrpedidofor= "'+this.pid+'"';
                    }else{
                        rfiltro = ' and pc.id='+this.pid;
                    }
                } 
                if(this.lstidfilial.length > 0){
                    rfiltro = ' and pc.id in (' + this.lstidfilial.join(',') + ')';
                }
                if(parseInt(this.psituacao) !== 4){
                    rfiltro = rfiltro +' and pc.situacao='+this.psituacao;
                }                              
                if (this.pidfilial !== null){
                    rfiltro = rfiltro +' and pc.idfilial='+this.pidfilial;
                }                
                if (this.pidfornecedor !== null){
                    rfiltro = rfiltro +' and pc.idfornecedor='+this.pidfornecedor;
                }
				if(parseInt(this.pfiltroperiodo) === 1){
                    if (parseInt(this.pfiltropor) === 0){
					    rfiltro = rfiltro + ' and pc.dtemissao between "' + util.InverterData(this.pdtini) + '" and "' + util.InverterData(this.pdtfim) + '"';
                    }else{
                        rfiltro = rfiltro + ' and pc.dtentrega between "' + util.InverterData(this.pdtini) + '" and "' + util.InverterData(this.pdtfim) + '"';                        
                    }
				}                
                return rfiltro;
            },
            mtdexecutapesquisa(){
                var vself           = this;
				if (vself.pidfilial === null && parseInt(vself.utodasfiliais) === 0){
					vself.$toastr.i('Seu usuário deve informar a filial para realização da consulta!', 'Informação!');
					return;
				}                
                let filtro          = vself.mtdfiltropesquisa();
                this.pagina_atual   = 1;
                let parametros      = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor  : 'qtdregistros'},
                    {parametro: 'filtro',       valor  : filtro}
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadpedidoscompra.php');
                retorno.then(function (response) {
                    vself.pqtd_total_registros = parseInt(response.data.qtdregistros);
                    let qtdpg                  = Math.ceil(vself.pqtd_total_registros / vself.pqtdregistros);
                    vself.pqtd_paginas         = qtdpg > 0 ? qtdpg : 1;
                    vself.mtdcarregapedidos(1);
                    vself.mtdexecutadash();
                   // vself.mtdgeratotais();
                }).catch(function (response) {
                    alert('Erro ao consultar registros');
                });
            },
            mtdcarregapedidos(ipagina){
                var vself       = this;
                let loader      = this.$loading.show();
                let filtro      = vself.mtdfiltropesquisa();
                let parametros  = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor : 'listagem'},
                    {parametro: 'filtro',       valor : filtro},
                    {parametro: 'limit',        valor : vself.pqtdregistros},
                    {parametro: 'offset',       valor : (parseInt(ipagina) -1) * parseInt(vself.pqtdregistros)},
                ];
                let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadpedidoscompra.php');
                retorno.then(function (response) {
                    vself.lstpedido   = response.data.pedidoscompra;
                    vself.vdigitacao  = response.data.digitacao;
                    vself.vaguardando = response.data.aguardando;
                    vself.ventregue   = response.data.entregue;
                    vself.vcancelado  = response.data.cancelado;
                    vself.lstidfilial = [];
                    
                    // vself.vqtddigitacao  = response.data.qtddigitacao;
                    // vself.vqtdaguardando = response.data.qtdaguardando;
                    // vself.vqtdentregue   = response.data.qtdentregue;
                    // vself.vqtdcancelado  = response.data.qtdcancelado;

                    if(vself.lstpedido.length > 0){
                        vself.mtdgeratotais();
                    }
                    
                    loader.hide();
                }).catch(function (response) {
                    vself.lstpedido = [];
                    loader.hide();
                });
            },
            resetarDados() {
                util.toTop();
                this.vitem                  = 0;
                this.vid                    = '';
                this.vidfilial              = null;
                this.vidfornecedor          = null;
                this.vnrpedidofor           = '';
                this.vdtemissao			    = util.DataAtual();
                this.vcondicoespagamento    = '';
                this.vobservacoes           = '';
                this.vsolicitante           = '';
                this.vtotalpedido           = 0;
                this.vimprimirvalores       = 0;
                this.vsituacao              = 0;
                this.lstitenspedido         = [];
                this.lstparcelas            = [];
                this.lstembarques           = [];

                this.$refs.reflstpedidos.selected_items = [];
                this.$refs.reflstpedidos.unSelectAllItems();

             

                $("#cbfilial").val(null).trigger('change');
                $("#cbfornecedor").val(null).trigger('change');


                this.mtdlimparedicaoitem();

            },
            mtddefault(){
                $('#pnlista').hide();
                this.resetarDados();
                $('#pncadastro').fadeIn(700);
                setTimeout(() => {
                    if (parseInt(this.opcrud) < 3) {                        
                        $('#cbfilial').select2('open');
                    } else {
                        $('#btgravar').focus();
                    }                    
                }, 200);
            },
            mtdpreparacrud(op) {
                let vself    = this;
                vself.opcrud = op;
                $('.nav-tabs a[href="#dvitens"]').tab('show');
                vself.mtddefault();
            },
            mtdnovo(){
                if (!util.opcaousuario('010Z.005Z.010Z', this.$store.state.perfilusuario)){
                    this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                }else {
                    this.itensbc.item2.titulo = 'INCLUSÃO DE PEDIDO DE COMPRA';
                    this.itensbc.item1.ativo = true;
                    this.itensbc.item2.ativo = true;
                    this.ativadesativa = false;
                    this.mtdpreparacrud(1);
                }
            },
            mtdcancelaredicao(){
                if(this.pedidocotacao){
                    this.pedidocotacao = []
                }
                this.itensbc.item1.ativo = false;
                this.itensbc.item2.ativo = false;
                this.clonar = false;
                $('#pncadastro').hide();
                $('#pnlista').fadeIn(700);
                $('#edconteudopesq').focus();
                setTimeout(function(){
                    util.toTop();
                }, 200);
            },
            mtdlimpar_listagem() {
                this.lstpedido = [];
                this.pagina_atual = 1;
                this.filtro = '';
                this.pqtd_total_registros = 0;
                this.pqtd_paginas = 0;
            },
            mtdgravar(){
                let vself = this;
                if (parseInt(vself.opcrud) < 3) {
                    if (parseInt(vself.vtodasfiliais) === 0) {
                    }
                }
                $.confirm({
                    title: 'Confirmação!',
                    content: 'Confirma ' + vself.itensbc.item2.titulo + '?',
                    icon: 'fa fa-question-circle',
                    escapeKey: true,
                    backgroundDismiss: false,
                    escapeKey: 'nao',
                    type: 'dark',
                    typeAnimated: true,
                    buttons: {
                        sim: {
                            text: '<u>S</u>im',
                            keys: ['s', 'S'],
                            btnClass: 'btn-blue',
                            action: function () {
                                $('.btn-blue').prop('disabled', true);

                                let totalparcelas = 0
                                for (let index = 0; index < vself.lstparcelas.length; index++) {
                                    totalparcelas = totalparcelas + vself.lstparcelas[index].vltit;
                                }
                                if(parseFloat(totalparcelas) > parseFloat(vself.vtotalpedido)){
                                    $.confirm({
                                        title: 'Confirmação!',
                                        content: 'O total das parcelas e embarques é maior que o total do pedido, deseja salvar?',
                                        icon: 'fa fa-question-circle',
                                        escapeKey: true,
                                        backgroundDismiss: false,
                                        escapeKey: 'nao',
                                        type: 'dark',
                                        typeAnimated: true,
                                        buttons: {
                                            sim: {
                                                text: '<u>S</u>im',
                                                keys: ['s', 'S'],
                                                btnClass: 'btn-blue',
                                                action: function () {
                                                    $('.btn-blue').prop('disabled', true);
                                                    vself.mtdregistro();
                                                },
                                            },
                                            nao: {
                                                text: '<u>N</u>ão',
                                                keys: ['n', 'N'],
                                                action: function () {
                                                    $('#btgravar').focus();
                                                }
                                            }
                                        }
                                    });
                                }else{
                                    vself.mtdregistro();
                                }
                            },
                        },
                        nao: {
                            text: '<u>N</u>ão',
                            keys: ['n', 'N'],
                            action: function () {
                                $('#btgravar').focus();
                            }
                        }
                    }
                });
            },
            mtdlocalizaregistro(id){
                var vself       = this;
                let loader      = vself.$loading.show();
                let filtro      = ' and pc.id='+id;
                let parametros  = [
                    {parametro: 'op',           valor : 'listagem'},
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'filtro',       valor : filtro},
                    {parametro: 'limit',        valor : 1},
                    {parametro: 'offset',       valor : 0},
                ];
                let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadpedidoscompra.php');
                retorno.then(function (response) {
                    loader.hide();
                    vself.mtdigualarcampos(response.data.pedidoscompra[0]);
                    if (parseInt(vself.opcrud) < 3){
                        $('#cbfilial').select2('open');
                    }else{
                        $('#btgravar').focus();
                    }
                }).catch(function (response) {
                    loader.hide();
                });
            },
            mtdalterar(item){
                $('#mdmenupedido').modal('hide');
                if (!util.opcaousuario('010Z.005Z.020Z', this.$store.state.perfilusuario)){
                    this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                }else {
                   // if((parseInt(item.situacao) === 2)||(!util.opcaousuario('010Z.005Z.045Z', this.$store.state.perfilusuario))){
                //    this.$toastr.i('Não é permitido alterar um pedido Entregue!', 'Informação!');
                   // }else{
                        this.itensbc.item2.titulo = 'ALTERAÇÃO DE PEDIDO DE COMPRA';
                        this.itensbc.item1.ativo = true;
                        this.itensbc.item2.ativo = true;
                        this.ativadesativa = false;
                        this.mtdpreparacrud(2);
                        this.mtdlocalizaregistro(item.id);
                   // }
                }
            },
            mtdclonar(item){
				let vself = this;
				$('#mdmenupedido').modal('hide');

				if (!util.opcaousuario('020Z.010Z.063Z', this.$store.state.perfilusuario)){
					this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
				}else {		
					this.itensbc.item2.titulo 	= 'INCLUSÃO DE PEDIDOS';
					this.itensbc.item1.ativo 	= true;
					this.itensbc.item2.ativo 	= true;
					this.ativadesativa 			= false;
                    this.vidtodasfil            = false;
					this.clonar                 = true;
					this.mtdpreparacrud(1);
					this.mtdlocalizaregistro(item.id);
                    vself.$nextTick(() => { 
                        $('[data-toggle="tooltip"]').tooltip();
                    });
					setTimeout(() => {
						vself.vid = '';
					}, 200);
				}
            },	
            mtdexcluir(item){
                $('#mdmenupedido').modal('hide');
                if (!util.opcaousuario('010Z.005Z.030Z', this.$store.state.perfilusuario)){
                    this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                }else {
                    if(item.idnotafor!=null){
                        this.$toastr.i('Não é possivel alterar um pedido que esteja vinculado a uma nota de fornecedor!', 'Informação!');
                        return
                    }
                    this.itensbc.item2.titulo = 'EXCLUSÃO DE PEDIDO DE COMPRA';
                    this.itensbc.item1.ativo = true;
                    this.itensbc.item2.ativo = true;
                    this.ativadesativa = true;
                    this.mtdpreparacrud(3);
                    this.mtdlocalizaregistro(item.id);
                }
            },
            mtdigualarcampos(registro){
                this.vid                    = registro.id;
                this.vidfilial              = registro.idfilial;
                this.vidfornecedor          = registro.idfornecedor;
                this.vnrpedidofor           = registro.nrpedidofor;
                this.vdtemissao			    = this.clonar ? util.DataAtual(true) : registro.dtemissao;
                this.vdtentrega			    = this.clonar ? util.DataAtual(true) : registro.dtentrega;
                this.vobservacoes           = registro.observacoes;
                this.vcondicoespagamento    = registro.condicoespagamento;               
                this.vsolicitante           = registro.solicitante;
                this.vtotalpedido           = parseFloat(registro.totalpedido);
                this.vimprimirvalores       = registro.imprimirvalores;
                this.vsituacao              = registro.situacao;
                this.lstitenspedido         = registro.itens;
                this.lstparcelas            = registro.parcelas;
                this.lstembarques           = registro.embarques;

             
                
                var deffilial  = new Option(registro.fantasiafilial, registro.idfilial, true, true);
				$('#cbfilial').append(deffilial).trigger('change');
                
                var defforn  = new Option(registro.fantasia, registro.idfornecedor, true, true);
				$('#cbfornecedor').append(defforn).trigger('change');


                this.vitem                  = this.lstitenspedido[this.lstitenspedido.length - 1].item;
            },
            mtdregistro(){
                let vself  = this;
                let loader = vself.$loading.show();
                vself.lstidfilial = [];
                if(vself.pedidocotacao){
                    vself.pedidocotacao = []
                }

                let definiop = vself.vidtodasfil ? "registrapedidotodasfilais" : "rotinacrud";
                let registrocrud = {
                    'id'                : this.vid,
                    'idfilial'          : vself.vidtodasfil ? this.todasfiliais : this.vidfilial,
                    'idfornecedor'      : this.vidfornecedor,
                    'nrpedidofor'       : this.vnrpedidofor,
                    'dtemissao'			: this.mtdformatadatagravar(this.vdtemissao),
                    'dtentrega'			: this.mtdformatadatagravar(this.vdtentrega),
                    'condicoespagamento': this.vcondicoespagamento,
                    'observacoes'       : this.vobservacoes,
                    'solicitante'       : this.vsolicitante,
                    'totalpedido'       : this.vtotalpedido,
                    'imprimirvalores'   : this.vimprimirvalores,
                    'situacao'          : this.vsituacao,
                    'itens'             : this.lstitenspedido,
                    'parcelas'          : this.lstparcelas,
                    'embarques'         : this.lstembarques
                };
                let parametros      = [
                    {parametro: 'idclientesac', valor : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor : definiop},
                    {parametro: 'opcrud',       valor : vself.opcrud},
                    {parametro: 'registro',     valor : JSON.stringify(registrocrud)},
                    {parametro: 'idfilial',     valor : vself.$store.state.filialpadrao.codfil},
                    {parametro: 'idusuario',    valor : vself.$store.state.usuario.id},
                    {parametro: 'codop',        valor : parseInt(this.opcrud) === 1 ? '010Z.005Z.010Z' : parseInt(this.opcrud) === 2 ? '010Z.005Z.020Z' : '010Z.005Z.030Z'},
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadpedidoscompra.php');
                retorno.then(function (response) {
                    loader.hide();
                    vself.clonar = false;
                    if ($.isNumeric(response.data)){
                        vself.$toastr.s('Registro processado com sucesso!', 'Informação!');
                        vself.pfiltroperiodo = 0;
                        vself.psituacao      = 4;
                        vself.pid            = parseInt(vself.opcrud) === 1 ? response.data : vself.vid;
                        vself.pqtd_paginas   = 1;
                        vself.mtdcancelaredicao();
                        vself.mtdcarregapedidos(1);
                    }else if(response.data){
                        vself.$toastr.s('Registro processado com sucesso!', 'Informação!');
                        vself.pfiltroperiodo = 0;
                        vself.psituacao      = 4;
                        vself.lstidfilial    = parseInt(vself.opcrud) === 1 ? response.data : vself.todasfiliais;
                        vself.pqtd_paginas   = 1;
                        vself.mtdcancelaredicao();
                        vself.mtdcarregapedidos(1);
                    }else{
                        let tpret = response.data.substring(0,1);
                        switch (tpret) {
                            case 'I':
                                vself.$toastr.w(response.data.substring(4), 'Atenção!');
                                break;
                            case 'E': default:
                                vself.$toastr.e(response.data.substring(4), 'Erro!');
                                break;
                        }
                    }
                }).catch(function (response) {
                    loader.hide();
                    vself.clonar = false;
                    vself.$toastr.e('Erro ao processar o registo. Descrição do erro: '+response.message, 'Erro!');
                });
            },			
			mtdlimparedicaoitem(){
				this.vidprodutoedicao    		= '';
				this.vcoddigedicao				= '';
				this.vdescricaoprodutoedicao 	= '';
				this.vundprodutoedicao			= '';
				this.vqtditemedicao				= 1;
				this.vfracionadoedicao			= 0;
				this.vreferenciaedicao  		= '';
                this.vvlunitarioedicao          = 0;
                this.vtotalitemedicao           = 0;     
                
                $("#cbmarca").val(null).trigger('change');
                $("#cbgrupo").val(null).trigger('change');
                $("#cbsetor").val(null).trigger('change');
			},
            mtdlocalizarproduto(coddig){
				if (coddig !== '' && coddig !== null){
					var vself       = this;
					let loader      = vself.$loading.show();
					let parametros  = [
						{parametro: 'op',               valor : 'listagem'},
						{parametro: 'idclientesac',     valor : vself.$store.state.filialpadrao.idcliente},
						{parametro: 'diretorioimagens', valor : vself.$store.state.configpaths.pathimgprodutos+vself.$store.state.filialpadrao.idcliente},
						{parametro: 'filtro',           valor : ''},
						{parametro: 'coddig',           valor : coddig},
						{parametro: 'limit',            valor : 1},
						{parametro: 'offset',           valor : 0},
					];
					let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadprodutos.php');
					retorno.then(function (response) {
						loader.hide();						
						if (response.data.length > 0){
							let produto = response.data[0];							
							vself.vidprodutoedicao			= produto.id;
							vself.vdescricaoprodutoedicao 	= produto.descricao;
							vself.vundprodutoedicao			= produto.und;
							vself.vfracionadoedicao			= produto.fracionado;
                            vself.vreferenciaedicao         = produto.referencia;
                            vself.vvlunitarioedicao         = produto.prcompra;

                            var defmarca  = new Option(produto.descmarca, produto.idmarca, true, true);
                            $('#cbmarca').append(defmarca).trigger('change');
                            
                            var defgrupo  = new Option(produto.descgrupo, produto.idgrupo, true, true);
                            $('#cbgrupo').append(defgrupo).trigger('change');

                            var defsetor  = new Option(produto.descsetor, produto.idsetor, true, true);
                            $('#cbsetor').append(defsetor).trigger('change');

							vself.$nextTick(function () {
								$('#edqtditemedicao').focus();
							});
						}else{
							vself.$toastr.w('Código informado não cadastrado no sistema!', 'Atenção!');
							vself.mtdlimparedicaoitem();
							$('#edidprodutoedicao').focus();
						}
					}).catch(function (response) {
						loader.hide();
					});
				}else{
					this.mtdlimparedicaoitem();
				}
            },			
            mtdconsultarproduto(){
				if (parseInt(this.opcrud) < 3){
					let payload = {
						abrirtela    : true			
					};
					this.$store.commit('CONSULTA_PRODUTO_CHANGE',payload);
					let payloadx = {
						idproduto    : null			
					};
					this.$store.commit('PRODUTO_RETORNO_CHANGE',payloadx);                
				}
			},
            mtdadicionaritem(){
				let vself = this;
				if (this.vcoddigedicao === ''){
					this.$toastr.w('Código do produto deve ser informado!', 'Atenção!');
					$('#edidprodutoedicao').focus();
					return;
				}
				if (parseFloat(this.vqtditemedicao) <= 0){
					this.$toastr.w('Quantidade inválida!', 'Atenção!');
					$('#edqtditemedicao').focus();
					return;
				}                
                if (parseInt(this.vfracionadoedicao) === 0){
                    if (!Number.isInteger(this.vqtditemedicao)){
						this.$toastr.w('Quantidade não pode ser FRACIONADA!', 'Atenção!');
						$('#edqtditemedicao').focus();
                        return;
                    }
				}
                if (parseFloat(this.vvlunitarioedicao) === 0){
                    this.$toastr.w('Informe um valor válido para o item!', 'Atenção!');
                    $('#edvlunitarioitemedicao').focus();
                    return;
				}
                if (this.vidmarca === null){
                    this.$toastr.w('Informe a marca na edição!', 'Atenção!');
                    return;
				}
                if (this.vidgrupo === null){
                    this.$toastr.w('Informe o grupo na edição!', 'Atenção!');
                    return;
				}   
                if (this.vidsetor === null){
                    this.$toastr.w('Informe o setor na edição!', 'Atenção!');
                    return;
				}                
                if (util.findValInArray(this.lstitenspedido, 'idproduto', this.vidprodutoedicao)){                                
                    this.$toastr.w('Item já lançado no pedido!', 'Atenção!');
                    return;
                }
                vself.vitem++;
                let itemtmp = {
                    item			: vself.vitem,
                    idproduto		: vself.vidprodutoedicao,
                    idmarca         : vself.vidmarca,
                    descmarca       : $('#cbmarca').select2('data')[0]['text'],
                    idgrupo         : vself.vidgrupo,
                    descgrupo       : $('#cbgrupo').select2('data')[0]['text'],
                    idsetor         : vself.vidsetor,
                    descsetor       : $('#cbsetor').select2('data')[0]['text'],
                    descricao		: vself.vdescricaoprodutoedicao,
                    referencia      : vself.vreferenciaedicao,
                    coddig			: vself.vcoddigedicao,                    
                    qtditem			: vself.vqtditemedicao,
                    und			    : vself.vundprodutoedicao,
                    fracionado      : vself.vfracionadoedicao,
                    vlunitario      : vself.vvlunitarioedicao,
                    idestoque       : vself.$store.state.filialpadrao.idestoque,
                    descestoque     : vself.$store.state.filialpadrao.descestoque, //pegar padrão do usuário
                    totalitem       : vself.vtotalitemedicao                    
                };         
                this.vtotalpedido = parseFloat(this.vtotalpedido) + parseFloat(this.vtotalitemedicao);
                vself.lstitenspedido.push(itemtmp);       
                vself.mtdlimparedicaoitem();
                setTimeout(() => {
                    $('#edidprodutoedicao').focus();
                }, 200);
            },
            mtdexcluiritem(item){
                if (parseInt(this.opcrud) < 3){
                    let indiceitem 		= util.getArrayIndexForKey(this.lstitenspedido, 'item', item.item);
                    this.vtotalpedido   = parseFloat(this.vtotalpedido) - parseFloat(this.lstitenspedido[indiceitem].totalitem);
                    this.lstitenspedido.splice(indiceitem, 1);                 
                }
            },
            mtdimportaritenscoletor(){
                let vself  = this;
                let loader = vself.$loading.show();
                let parametros      = [
                    {parametro: 'idclientesac', valor : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor : 'listarcoletor'},
                    {parametro: 'idusuario',    valor : vself.$store.state.usuario.id}
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rotinasusuario.php');
                retorno.then(function (response) {
                    loader.hide();
                    if ($.isNumeric(response.data.inf)){
                        let itenstmp = response.data.itenscoletor;
                        if (vself.lstitenspedido.length > 0){
                            vself.vitem  = vself.lstitenspedido[vself.lstitenspedido.length - 1].item;
                        }else{
                            vself.vitem  = 0;
                        }
                        for (let i = 0; i < itenstmp.length; i++) {
                            if (util.findValInArray(vself.lstitenspedido, 'idproduto', itenstmp[i].idproduto)){
                                let ii = util.getArrayIndexForKey(vself.lstitenspedido, 'idproduto', itenstmp[i].idproduto); 
                                vself.lstitenspedido[ii].qtditem   = parseFloat(vself.lstitenspedido[ii].qtditem) + parseFloat(itenstmp[i].qtd);
                                vself.lstitenspedido[ii].totalitem = parseFloat(vself.lstitenspedido[ii].totalitem) + (parseFloat(itenstmp[i].qtd) * parseFloat(itenstmp[i].prcompra));
                                vself.vtotalpedido = parseFloat(vself.vtotalpedido) + (parseFloat(itenstmp[i].qtd) * parseFloat(itenstmp[i].prcompra));
                            }else{  
                                vself.vitem++;
                                let itemtmp = {
                                    item			: vself.vitem,
                                    idproduto		: itenstmp[i].idproduto,
                                    descricao		: itenstmp[i].descricao,
                                    referencia      : itenstmp[i].referencia,
                                    idgrupo         : itenstmp[i].idgrupo,
                                    descgrupo       : itenstmp[i].descgrupo,
                                    idmarca         : itenstmp[i].idmarca,
                                    descmarca       : itenstmp[i].descmarca,
                                    idsetor         : itenstmp[i].idsetor,
                                    descsetor       : itenstmp[i].descsetor,
                                    idestoque       : vself.$store.state.filialpadrao.idestoque,
                                    coddig			: '',                    
                                    qtditem			: itenstmp[i].qtd,
                                    und			    : itenstmp[i].und,
                                    vlunitario      : itenstmp[i].prcompra,
                                    totalitem       : parseFloat(itenstmp[i].prcompra) * parseFloat(itenstmp[i].qtd)
                                };
                                vself.vtotalpedido = parseFloat(vself.vtotalpedido) + parseFloat(itemtmp.totalitem);
                                vself.lstitenspedido.push(itemtmp);                        
                            }
                        }                        
                    }
                }).catch(function (response) {
                    loader.hide();
                }); 
            },
            mtdcalculatotalitem(){
                this.vtotalitemedicao = parseFloat(this.vqtditemedicao) * parseFloat(this.vvlunitarioedicao);
            },
			mtdimprimirpedidocompra(idpedido, tp){				
                $('#mdmenupedido').modal('hide');
				window.open(this.$store.state.configpaths.pathcontrole+'rtimprimirpedidocompra.php?idclientesac='+
							this.$store.state.filialpadrao.idcliente+
							'&idpedido='+idpedido+'&idu='+
							this.$store.state.usuario.id, '_blank');				
			},
            mtdalteraritem(item){
                this.vitemalt       = JSON.parse(JSON.stringify(item));                
                this.vqtditemalt    = this.vitemalt.qtditem;
                this.vvlunitarioalt = this.vitemalt.vlunitario;

                var defmarcaalt  = new Option(this.vitemalt.descmarca, this.vitemalt.idmarca, true, true);
				$('#cbmarcaalt').append(defmarcaalt).trigger('change');

                var defgrupoalt  = new Option(this.vitemalt.descgrupo, this.vitemalt.idgrupo, true, true);
				$('#cbgrupoalt').append(defgrupoalt).trigger('change');

                var defsetoralt  = new Option(this.vitemalt.descsetor, this.vitemalt.idsetor, true, true);
				$('#cbsetoralt').append(defsetoralt).trigger('change');

                $('#mdealteraitem').modal('show');
            },
            mtdcalculatotalalt(){
                this.vtotalitemalt = parseFloat(this.vqtditemalt) * parseFloat(this.vvlunitarioalt);
            },
            mtdconfirmaralteracao(){
				if (parseFloat(this.vqtditemalt) <= 0){
					this.$toastr.w('Quantidade inválida!', 'Atenção!');
					$('#edqtditemalt').focus();
					return;
				} 
                if (parseInt(this.vitemalt.fracionado) === 0){
                    if (!Number.isInteger(this.vqtditemalt)){
						this.$toastr.w('Quantidade não pode ser FRACIONADA!', 'Atenção!');
						$('#edqtditemalt').focus();
                        return;
                    }
				}                               
                if (parseFloat(this.vvlunitarioalt) === 0){
                    this.$toastr.w('Informe um valor válido para o item!', 'Atenção!');
                    $('#edvlunitarioitemalt').focus();
                    return;
				}
                if(this.vidmarcaalt===null){
                    this.$toastr.w('Informe a marca deste item!', 'Atenção!');
                    $('#cbmarcaalt').focus();
                    return;
                }   
                if(this.vidgrupoalt===null){
                    this.$toastr.w('Informe o grupo deste item!', 'Atenção!');
                    $('#cbgrupoalt').focus();
                    return;
                }   
                if(this.vidsetoralt===null){
                    this.$toastr.w('Informe o grupo deste item!', 'Atenção!');
                    $('#cbsetoralt').focus();
                    return;
                } 
                let inditem         = util.getArrayIndexForKey(this.lstitenspedido, 'idproduto', this.vitemalt.idproduto);             
                this.vtotalpedido   = parseFloat(this.vtotalpedido) - parseFloat(this.lstitenspedido[inditem].totalitem);

                this.lstitenspedido[inditem].qtditem    = parseFloat(this.vqtditemalt);
                this.lstitenspedido[inditem].vlunitario = parseFloat(this.vvlunitarioalt);
                this.lstitenspedido[inditem].totalitem  = parseFloat(this.vtotalitemalt);
                this.lstitenspedido[inditem].idmarca    = this.vidmarcaalt;
                this.lstitenspedido[inditem].idgrupo    = this.vidgrupoalt;
                this.lstitenspedido[inditem].idsetor    = this.vidsetoralt;
                this.lstitenspedido[inditem].descmarca  = $('#cbmarcaalt').select2('data')[0]['text'];
                this.lstitenspedido[inditem].descgrupo  = $('#cbgrupoalt').select2('data')[0]['text'];
                this.lstitenspedido[inditem].descsetor  = $('#cbsetoralt').select2('data')[0]['text'];

                this.vtotalpedido   = parseFloat(this.vtotalpedido) + parseFloat(this.vtotalitemalt);

                this.vitemalt       = [];                
                this.vqtditemalt    = 1;
                this.vvlunitarioalt = 0;
                $('#mdealteraitem').modal('hide');                
            },
            mtddetalharimpfil(excel = 1){
                let vself = this;

                $.confirm({
                    title: 'Confirmação!',
                    content: 'Detalhar filial na impressão?',
                    icon: 'fa fa-question-circle',
                    escapeKey: true,
                    backgroundDismiss: false,
                    escapeKey: 'nao',
                    type: 'dark',
                    typeAnimated: true,
                    buttons: {
                        sim: {
                            text: '<u>S</u>im',
                            keys: ['s', 'S'],
                            btnClass: 'btn-blue',
                            action: function () {
                                $('.btn-blue').prop('disabled', true);
                                vself.detalharfilial = 1;
                                vself.mtdimprimirlistagem(excel);
                            },
                        },
                        nao: {
                            text: '<u>N</u>ão',
                            keys: ['n', 'N'],
                            action: function () {
                                vself.detalharfilial = 0;
                                vself.mtdimprimirlistagem(excel);
                            }
                        }
                    }
                });
            },

            mtdimpmarca(excel = 1){
                let vself = this;

                $.confirm({
                    title: 'Confirmação!',
                    content: 'Agrupar por filial na impressão?',
                    icon: 'fa fa-question-circle',
                    escapeKey: true,
                    backgroundDismiss: false,
                    escapeKey: 'nao',
                    type: 'dark',
                    typeAnimated: true,
                    buttons: {
                        sim: {
                            text: '<u>S</u>im',
                            keys: ['s', 'S'],
                            btnClass: 'btn-blue',
                            action: function () {
                                $('.btn-blue').prop('disabled', true);
                                vself.detalharfilialimpmarca = 1;
                                vself.mtdimpressaomarca(excel);
                            },
                        },
                        nao: {
                            text: '<u>N</u>ão',
                            keys: ['n', 'N'],
                            action: function () {
                                vself.detalharfilialimpmarca = 0;
                                vself.mtdimpressaomarca(excel);
                            }
                        }
                    }
                });
            },

            // mtddetalharimpfil(){
            //     let vself = this;

            //     $.confirm({
            //         title: 'Confirmação!',
            //         content: 'Detalhar filial na impressão?',
            //         icon: 'fa fa-question-circle',
            //         escapeKey: true,
            //         backgroundDismiss: false,
            //         escapeKey: 'nao',
            //         type: 'dark',
            //         typeAnimated: true,
            //         buttons: {
            //             sim: {
            //                 text: '<u>S</u>im',
            //                 keys: ['s', 'S'],
            //                 btnClass: 'btn-blue',
            //                 action: function () {
            //                     $('.btn-blue').prop('disabled', true);
            //                     vself.detalharfilial = 1;
            //                     vself.mtdimprimirlistagem();
            //                 },
            //             },
            //             nao: {
            //                 text: '<u>N</u>ão',
            //                 keys: ['n', 'N'],
            //                 action: function () {
            //                     vself.detalharfilial = 0;
            //                     vself.mtdimprimirlistagem();
            //                 }
            //             }
            //         }
            //     });
            // },
            // mtdimpmarca(){
            //     let vself = this;

            //     $.confirm({
            //         title: 'Confirmação!',
            //         content: 'Agrupar por filial na impressão?',
            //         icon: 'fa fa-question-circle',
            //         escapeKey: true,
            //         backgroundDismiss: false,
            //         escapeKey: 'nao',
            //         type: 'dark',
            //         typeAnimated: true,
            //         buttons: {
            //             sim: {
            //                 text: '<u>S</u>im',
            //                 keys: ['s', 'S'],
            //                 btnClass: 'btn-blue',
            //                 action: function () {
            //                     $('.btn-blue').prop('disabled', true);
            //                     vself.detalharfilialimpmarca = 1;
            //                     vself.mtdimpressaomarca();
            //                 },
            //             },
            //             nao: {
            //                 text: '<u>N</u>ão',
            //                 keys: ['n', 'N'],
            //                 action: function () {
            //                     vself.detalharfilialimpmarca = 0;
            //                     vself.mtdimpressaomarca();
            //                 }
            //             }
            //         }
            //     });
            // },
            // mtdimprimirlistagem(){
            //     let vself   = this;              
            //     let filtro  = vself.mtdfiltropesquisa();
            //     let dtini   = parseInt(vself.pfiltroperiodo) === 0 ? '2010-01-01' : util.InverterData(vself.pdtini);
            //     let dtfim   = util.InverterData(vself.pdtfim);
            //     let src     = vself.presumoped ? '1' : '0';
            //     let filial  = vself.pidfilial === null ? 'TODAS AS FILIAIS' : $('#cbfilialpesq').select2('data')[0]['text'];
			// 	window.open(vself.$store.state.configpaths.pathcontrole+'rtcadpedidoscompra.php?idclientesac='+
			// 				vself.$store.state.filialpadrao.idcliente+
            //                 '&filtro='+filtro+
            //                 '&oprelatorio=1'+
            //                 '&dtini='+dtini+
            //                 '&dtfim='+dtfim+
            //                 '&rc='+src+
            //                 '&filial='+filial+
            //                 '&detfil='+vself.detalharfilial+
            //                 '&usuario='+vself.$store.state.usuario.nome, '_blank');					                                
            // },       
            // mtdimpressaomarca(){
            //     let vself   = this;              
            //     let filtro  = vself.mtdfiltropesquisa();
            //     let dtini   = parseInt(vself.pfiltroperiodo) === 0 ? '2010-01-01' : util.InverterData(vself.pdtini);
            //     let dtfim   = util.InverterData(vself.pdtfim);
            //     let src     = vself.presumoped ? '1' : '0';
            //     let filial  = vself.pidfilial === null ? 'TODAS AS FILIAIS' : $('#cbfilialpesq').select2('data')[0]['text'];
			// 	window.open(vself.$store.state.configpaths.pathcontrole+'rtcadpedidoscompra.php?idclientesac='+
			// 				vself.$store.state.filialpadrao.idcliente+
            //                 '&filtro='+filtro+
            //                 '&oprelatorio=2'+
            //                 '&dtini='+dtini+
            //                 '&dtfim='+dtfim+
            //                 '&rc='+src+
            //                 '&filial='+filial+
            //                 '&detfil='+vself.detalharfilialimpmarca+
            //                 '&usuario='+vself.$store.state.usuario.nome, '_blank');					                                
            // },
            mtdimprimirlistagem(excel = 1){
                let vself   = this;              
                let filtro  = vself.mtdfiltropesquisa();
                let dtini   = parseInt(vself.pfiltroperiodo) === 0 ? '2010-01-01' : util.InverterData(vself.pdtini);
                let dtfim   = util.InverterData(vself.pdtfim);
                let src     = vself.presumoped ? '1' : '0';
                let filial  = vself.pidfilial === null ? 'TODAS AS FILIAIS' : $('#cbfilialpesq').select2('data')[0]['text'];
                
                window.open(vself.$store.state.configpaths.pathcontrole+'rtcadpedidoscompra.php?idclientesac='+
                            vself.$store.state.filialpadrao.idcliente+
                            '&filtro='+filtro+
                            '&oprelatorio=1'+
                            '&dtini='+dtini+
                            '&dtfim='+dtfim+
                            '&rc='+src+
                            '&filial='+filial+
                            '&detfil='+vself.detalharfilial+
                            '&excel='+excel+
                            '&usuario='+vself.$store.state.usuario.nome, '_blank');					                                
            },

            mtdimpressaomarca(excel = 0){
                let vself   = this;              
                let filtro  = vself.mtdfiltropesquisa();
                let dtini   = parseInt(vself.pfiltroperiodo) === 0 ? '2010-01-01' : util.InverterData(vself.pdtini);
                let dtfim   = util.InverterData(vself.pdtfim);
                let src     = vself.presumoped ? '1' : '0';
                let filial  = vself.pidfilial === null ? 'TODAS AS FILIAIS' : $('#cbfilialpesq').select2('data')[0]['text'];

                window.open(vself.$store.state.configpaths.pathcontrole+'rtcadpedidoscompra.php?idclientesac='+
                            vself.$store.state.filialpadrao.idcliente+
                            '&filtro='+filtro+
                            '&oprelatorio=2'+
                            '&dtini='+dtini+
                            '&dtfim='+dtfim+
                            '&rc='+src+
                            '&filial='+filial+
                            '&detfil='+vself.detalharfilialimpmarca+
                            '&excel='+excel+
                            '&usuario='+vself.$store.state.usuario.nome, '_blank');					                                
            },

            mtdselecionatodasfiliais(){
                let vself = this;
                if(vself.vidtodasfil){
                    let loader = this.$loading.show();
                    $('#cbfilial').val(null).trigger('change');
    
                    let parametros  = [
                        {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                        {parametro: 'op',           valor : 'listagemsimplesfiliais'},
                        {parametro: 'limit',        valor : 9999999},
                        {parametro: 'offset',       valor : (parseInt(1) -1) * parseInt(vself.pqtdregistros)},
                    ];
                    let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadpedidoscompra.php');
                    retorno.then(function (response) {
                        vself.todasfiliais = response.data;
                        loader.hide();
                    }).catch(function (response) {
                        console.log(response.message);
                        vself.todasfiliais = [];
                        loader.hide();
                    });
                }
                // console.log(vself.todasfiliais);
            },
            mtdlocalizacotacao(pedido){
                if (!util.opcaousuario('010Z.005Z.010Z', this.$store.state.perfilusuario)){
                    this.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                }else {
                    this.itensbc.item2.titulo = 'INCLUSÃO DE PEDIDO DE COMPRA';
                    this.itensbc.item1.ativo = true;
                    this.itensbc.item2.ativo = true;
                    this.ativadesativa = false;
                    this.opcrud = 1;
                }
                this.resetarDados()
                $('#pnlista').hide();
                $('#pncadastro').fadeIn(700);
                this.mtdgerapedido(JSON.parse(pedido));
            },
            mtdgerapedido(pedido){
                let totalpedido = 0;
                this.lstitenspedido = pedido.produtoscotacao.map((pedido, index)=>{
                    let itens = {
                        ...pedido,
                        totalitem : pedido.vlunitario * pedido.qtditem,
                        item : index + 1
                    }
                    return itens;
                });
                
                if(!pedido.totalpedido){
                    let  totalizadoritens = this.lstitenspedido.map((p)=>  p.totalitem);
                    totalpedido = totalizadoritens.reduce((totalprodutos, totalitem) => {
                        return totalprodutos + totalitem;
                    }, 0);
                }

                this.vid                    = pedido.id;
                this.vidfilial              = pedido.idfilial;
                this.vidfornecedor          = pedido.idfornecedor;
                this.vnrpedidofor           = pedido.nrpedidofor;
                this.vdtemissao			    = util.DataAtual(true);
                this.vdtentrega			    = util.DataAtual(true);
                this.vobservacoes           = pedido.observacao;
                this.vtotalpedido           = pedido.totalpedido ? parseFloat(pedido.totalpedido) : totalpedido;


             
                
                var deffilial  = new Option(pedido.fantasiafil, pedido.idfilial, true, true);
				$('#cbfilial').append(deffilial).trigger('change');
                
                var defforn  = new Option(pedido.nomerazaosocial, pedido.idfornecedor, true, true);
				$('#cbfornecedor').append(defforn).trigger('change');

            },
        },
        mounted: function () {
        
            if (util.verificasessao(this)) {
                let vself = this;
                vself.utodasfiliais = vself.$store.state.usuario.todasfiliais;
                let loader = vself.$loading.show();
                let parametros = [
                    {parametro: 'op', valor: 'dadosusuario'},
                    {parametro: 'idclientesac', valor  : vself.$store.state.usuario.idclientesac},
                    {parametro: 'idusuario', valor: vself.$store.state.usuario.id}
                ];
                let retorno = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rotinasusuario.php');
                retorno.then(function (response) {
                    loader.hide();
                    vself.$store.commit('MUDAR_PERFIL_USUARIO', response.data.perfilusu);
                    if (parseInt(vself.$store.state.filialpadrao.plnc) < 2){
                        vself.$swal.fire({
                                            position: 'bottom-end',
                                            //icon: 'success',
                                            title: 'Atenção!',
                                            html: 'Seu plano não contempla esta funcionalidade! Favor entrar em contato com a <strong>Rillsoft Sistemas</strong> para mais informações.',
                                            showConfirmButton: false,
                                            showCloseButton: true,
                                            backdrop: false                                                
                                        }); 
                        setTimeout(function(){
                            util.gotoprincipal();
                        },4000);                                                               
                    }                    
                    if (util.opcaousuario('010Z.005Z', vself.$store.state.perfilusuario)) {
                        vself.vhabrelacaopedcompra   = util.opcaousuario('010Z.010Z.050Z', vself.$store.state.perfilusuario);
                        $('#pnlista').fadeIn(700);
                        vself.mtddefiniciais();
                        vself.mtdexecutapesquisa();
                        vself.pedidocotacao = window.localStorage.getItem('dadospedidocompra');
                        if(vself.pedidocotacao){
                            vself.mtdlocalizacotacao(vself.pedidocotacao);
                            window.localStorage.removeItem('dadospedidocompra');
                        }else{
                            vself.pedidocotacao = [];
                            window.localStorage.removeItem('dadospedidocompra');
                        }
                        //vself.mtdgeratotais();
                    } else {
                        vself.$toastr.i('Acesso não permitido para o usuário!', 'Informação!');
                        setTimeout(function(){
                            util.gotoprincipal();
                        },1000);
                    }
                }).catch(function (response) {
                    loader.hide();
                    console.log(response.message);
                });


    
            }
        },
        computed:{
            validou() {
                let validafil = this.vidtodasfil ? this.vidtodasfil : this.vidfilial;
                return !validafil || this.vidfornecedor === null || this.vdtemissao === null || this.vdtentrega === null ||
                this.vsolicitante === '' || this.vcondicoespagamento === '' || this.lstitenspedido.length === 0; 
            },
            idprodutoretorno(){
                return this.$store.state.produtoretornoconsulta.idproduto;
            },
            selecionaperiodo() {
				if(parseInt(this.pfiltroperiodo) === 0){
					this.hab_desab_periodo = true;
				}else{
					this.hab_desab_periodo = false;
				}
            },
        },
        watch:{
            vtppesqu(val){
                this.mtdmudarfiltropedido(val);
            },
            lstparcelas(){
                if(this.lstparcelas.length===0){
                    this.lstembarques = [];
                }
            },
            presumoped(){
                this.mtdgeratotais();
            },
            pagina_atual(val){
                this.mtdcarregapedidos(val);
            },			
            idprodutoretorno(val){
                if (val !== null || val !== ''){
					this.vcoddigedicao = val;
					this.mtdlocalizarproduto(this.vcoddigedicao);					
                }
			},
            vqtditemedicao(){
                this.mtdcalculatotalitem(); 
            },
            vvlunitarioedicao(val){
               this.mtdcalculatotalitem(); 
            },
            vqtditemalt(){
                this.mtdcalculatotalalt(); 
            },
            vvlunitarioalt(val){
               this.mtdcalculatotalalt(); 
            },
            vtotalpedido(newVal, oldVal) {
                if (oldVal !== 0 && newVal !== 0) {
                    $.confirm({
                        title: 'Confirmação!',
                        content: 'Deseja atualizar automaticamente as parcelas com o novo valor?',
                        icon: 'fa fa-question-circle',
                        escapeKey: true,
                        backgroundDismiss: false,
                        escapeKey: 'nao',
                        type: 'orange',
                        typeAnimated: true,
                        buttons: {
                            sim: {
                                text: '<u>S</u>im',
                                keys: ['s', 'S'],
                                btnClass: 'btn-blue',
                                action: () => {
                                    this.mtdparcelaspagamento(newVal, oldVal);
                                    this.$toastr.s('Parcelas atualizadas com sucesso!', 'Sucesso');
                                },
                            },
                            nao: {
                                text: '<u>N</u>ão',
                                keys: ['n', 'N'],
                                action: () => {
                                    this.$toastr.i('Alteração do valor do pedido realizada, mas parcelas não foram atualizadas.', 'Informação');
                                }
                            }
                        }
                    });
                }
            },

        }
    }
</script>
<style>
    @media (max-width: 576px) {

        .grafico-line .echarts{
            width: 300px;
            height: 250px;        
        }        
    }  
    @media (min-width: 577px) {
     
        .grafico-line .echarts{
            width: 550px;
            height: 220px;        
        }        
    }  
    @media (min-width: 1024px) {
        
        .grafico-line .echarts{
            width: 1024px;
            height: 400px;        
        }        
    }
    @media print{
        .grafico-line .echarts{
            width: 1024px;
            height: 400px;  
            margin: 0;      
        }    
    }   
    .corverde{
        background-color: rgb(51, 148, 116) !important;
        border-color: rgb(51, 148, 116) !important;
    }
    .nrfor{
        width: 30px !important;
    }
    .def-col-cod{
        width: 100px !important;
    }
    .def-col-opcoes-compra{
        width: 70px !important;
    }
    .def-col-situacao{
        width: 90px !important;
    }
    .bdg-digitacao{
        background: #6BA2D0!important;        
    }
    .bdg-aguardando{
        background: #EEA435!important;
        color: white;
    }
    .bdg-entregue{
        background: #5A956A!important;
    }
    .bdg-cancelado{
        background: #cc330d!important;
    }
    .bgdigitacao{
        background: #6BA2D0!important;
        width: 120px;
        font-size: 14px !important;
        text-align: right !important;
    }
    .bgaguardando{
        background: #EEA435!important;
        width: 120px;
        font-size: 14px !important;
        text-align: right !important;
    }
    .bgentregue{
        background: #5A956A!important;
        width: 120px;
        font-size: 14px !important;
        text-align: right !important;
    }
    .bgcancelados{
        background: #cc330d!important;
        width: 120px;
        font-size: 14px !important;
        text-align: right !important;
    }
    .dgl{
        background: #6BA2D0!important;
    }
    .agl{
        background: #EEA435!important;
    }
    .enl{
        background: #5A956A!important;
    }
    .cal{
        background: #cc330d!important;
    }
    
</style>